import { inject, Injectable, NgZone, OnDestroy } from "@angular/core";
import { AppManagerService, DroppedWidgetInfo, WidgetPropertiesProvider } from "@wms/design-container";
import { EventManagerService } from "@wms/app";
import { MarkupManagerService } from "@wms/core";
import { $watch, getValidJSON } from '@wm/core';
import { PrefabManager } from "@wms/page-workspace";
import { find, forEach, get, isEmpty, isEqual, set } from "lodash-es";
import { debounceTime, fromEvent, Subject, Subscription, takeUntil } from "rxjs";

interface OverlayDimensions {
  width: number;
  height: number;
  top: number;
  left: number;
}
let CLASS = {
  'ACTIVE_WIDGET': 'canvas-active-widget',
  'DROP_TARGET_PARENT': 'widget-drop-target' // THIS CLASS IS NO LONGER USED, BUT KEPT FOR REFERENCE
};
let $widget: any;
let lastActiveWidPos: any,
  // $dropPrediction: JQuery<HTMLElement>,
  $focusNode: JQuery<HTMLElement>;

import DropEvent = JQuery.DropEvent;
import DragStartEvent = JQuery.DragStartEvent;
import DragEndEvent = JQuery.DragEndEvent;
import DragOverEvent = JQuery.DragOverEvent;
import { widgetInfo } from "./wm-canvas-dom.component";
import { isDefined, runtimeEventManager } from "@wm/core";
import ClickEvent = JQuery.ClickEvent;
import {DialogService, I18nService, NotificationService, ProjectService} from "@wms/services";
import {WmsWorkspaceManagerService} from "@wms/workspace";
import { ZoomService } from "@wms/app/workspace/page-workspace/services/zoom.service";
import { PageStructureService } from "@wms/app/workspace/page-workspace/services/page-structure.service";

// let DROP_PRED_WID_ID = '__drop_prediction__',
let addWidgetInfo: widgetInfo = {};
let ACTIONS = { ADD: 1, MOVE: 2 };
let lastHoverWidId: any = undefined;
let ANIMATION_DURATION = 100; // NO LONGER USED FOR PREDICTION ANIMATIONS
let addPosDetermined: boolean, movePosChanged: boolean, action: number | undefined, moveSuccess: boolean;
let prefabSkipEventSubGroups = ['prefablifecycleevents'];
let lastPos: { [key: string]: number | undefined } = {
  pageX: undefined,
  pageY: undefined
};

// VARIABLES FOR HIGHLIGHT TRACKING
let currentHighlightTarget: JQuery<HTMLElement> | null = null;
let currentHighlightParent: JQuery<HTMLElement> | null = null; // TO TRACK THE CONTAINER FOR DOTTED HIGHLIGHT
let currentHighlightSide: 'left' | 'right' | 'top' | 'bottom' | 'inside' | null = null;
let isHighlighted: boolean = false; // SINGLE FLAG FOR WHETHER A VALID HIGHLIGHT IS SET

@Injectable({
  providedIn: 'root'
})
export class CanvasDomService implements OnDestroy {
  private $$canvas: JQuery<HTMLElement>;
  private projectService: ProjectService;
  private eventManager: EventManagerService;
  private widgetProperties: WidgetPropertiesProvider;
  private appManager: AppManagerService;
  private registerDestroyListener: Subscription = new Subscription();
  private activeWidgetResizeObserver: ResizeObserver;
  private wsManager: WmsWorkspaceManagerService;
  private dialogService: DialogService;
  private notificationService: NotificationService;
  private locale: any;
  private destroy$ = new Subject<void>();

  private $selectedWidgets: JQuery<HTMLElement> = $();
  private selectionSet: Set<string> = new Set<string>();
  private selectedFocusNodes: Map<string, { clone: JQuery<HTMLElement>, widgetEl: JQuery<HTMLElement> }> = new Map();

  private _hoverRafId: number | null = null;
  private _pendingMouseEvent: any = null;
  private _lastHoverShiftKey: boolean | null = null;
  private _lastMouseClientX: number | null = null;
  private _lastMouseClientY: number | null = null;

  private _lastValidHoverTarget: JQuery<HTMLElement> | null = null;
  private _lastHoverTarget: JQuery<HTMLElement> | null = null;
  private _lastHoverSiblings: JQuery<HTMLElement> | null = null;
  private _lastSelectedWidget: JQuery<HTMLElement> | null = null;

  private _hoverTooltipEl: JQuery<HTMLElement> | null = null;

  private _shiftPressed: boolean = false;
  private _shiftSiblingsCollection: JQuery<HTMLElement> | null = null;

  // VARIABLES FOR RAF THROTTLING APPROACH
  private _pendingDragEvent: any = null;
  private _dragRafId: number | null = null;

  private _dropLineEl: JQuery<HTMLElement> | null = null;
  private _dropLabelEl: JQuery<HTMLElement> | null = null;
  private _currentLabelContainerId: string | null = null; // to avoid reflows when unchanged

  private readonly DROP_LINE_MAX_LENGTH = 100; // px, tweak as needed
  private readonly DROP_LINE_MIN_RATIO = 0.8;   // use 80% of available space when < max
  private readonly DROP_LINE_WIDTH = 3; // px
  private readonly DROP_LABEL_OFFSET = 0;      // px space between container top and label
  private readonly ROW_OVERLAP_TOLERANCE = 1; // px - tweak to tune row grouping
  private readonly ROW_OVERLAP_RATIO = 0.15; // fraction of min(height,rowHeight) required to consider overlapping
  private readonly ROW_OVERLAP_MIN_PX = 1;   // minimum px overlap to consider rows same


  private _dragPreviewEl: JQuery<HTMLElement> | null = null;
  private isPrism: boolean;
  private alreadySelectedCategory: string | null = null;
  private isPsTreeShown:boolean = false;

  constructor(private prefabManager: PrefabManager, private zoomService: ZoomService, private markupManager: MarkupManagerService, private ngZone: NgZone, private pageStructureService: PageStructureService) {
    this.eventManager = inject(EventManagerService);
    this.widgetProperties = inject(WidgetPropertiesProvider);
    this.appManager = inject(AppManagerService);
    this.projectService = inject(ProjectService);
    this.wsManager = inject(WmsWorkspaceManagerService);
    this.dialogService = inject(DialogService);
    this.notificationService = inject(NotificationService);
    let localeService = inject(I18nService);
    this.locale = localeService.getMessages();

    this.registerDestroyListener.add(this.appManager.subscribe('pageReady', (data: any) => {
      // this.defineDnd();
      // @ts-ignore
      // this.$$canvas?.off('.canvas-dom').on('click.canvas-dom', this.clickHandler.bind(this));

      // // Focus on root on page ready
      // const initiailWidgetId = this.markupManager?.getMarkup()?.children().first().attr('widget-id');
      // $widget = this.$$canvas?.find("[widget-id=" + initiailWidgetId + "]");
      // if($widget){
      //   this.updateFocusNodePos();
      //   $focusNode?.removeClass('ng-hide');
      // }
    }));

    this.registerDestroyListener.add(this.eventManager.partialParamsObservable().subscribe((data) => {
      this.onPartialParamsModified(data);
    }))

    runtimeEventManager.off('partial-container-params-modified');
    runtimeEventManager.on('partial-container-params-modified').subscribe((data) => this.onPartialParamsModified(data));

    this.registerDestroyListener.add(this.eventManager.onCanvasDrag$().subscribe(info => {
      $focusNode?.addClass('ng-hide');
      addWidgetInfo = info;
      action = ACTIONS.ADD;

      // DISABLE HOVER EFFECTS DURING DRAG
      this.$$canvas?.find('.hover-highlight, .hover-sibling, .hover-sibling-allowed').removeClass('hover-highlight hover-sibling hover-sibling-allowed');
      this.$$canvas?.off('mousemove.selection mouseleave.selection');
      this.unObserveResizeObserver();

      // RESET HIGHLIGHT
      this.clearDropHighlight();
      isHighlighted = false;
    }));

    this.registerDestroyListener.add(this.eventManager.canvasAddWidgetDragEndEventObservable().subscribe(() => {
      this.cleanupAddWidCancel();
      this.hideTreeNode();

      // RE-ENABLE HOVER EFFECTS AFTER DRAG END
      this.attachMouseEvents();

      // Trigger synthetic hover on the item under the last cursor position (using last dragover coords)
      if (this._lastMouseClientX != null && this._lastMouseClientY != null) {
        this._triggerSyntheticHover(this._shiftPressed);
      }
    }));

    this.registerDestroyListener.add(this.eventManager.widgetSelectionObservable().subscribe(() => {
      this.clickHandler.bind(this)
    }));

    this.registerDestroyListener.add(this.eventManager.widgetRearrangeObservable().subscribe((data) => {
      this.widgetRearrange(data);
    }))
    
    let projectService = runtimeEventManager.getService('projectService');
    this.isPrism = projectService.isPrism();
    if(this.isPrism){ // Handle multiselect autolayout only for prism projects
      // global Shift key handling: when pressed, show siblings highlight (if selection exists)
      this.registerDestroyListener.add(
        fromEvent<KeyboardEvent>(document, 'keydown')
          .pipe(takeUntil(this.destroy$))
          .subscribe((ev) => {
            if (ev.key === 'Shift' && !this._shiftPressed) {
              this._shiftPressed = true;
              this._applyShiftSiblingsHighlight();
              this._triggerSyntheticHover(true);
            }
          })
      );

      this.registerDestroyListener.add(
        fromEvent<KeyboardEvent>(document, 'keyup')
          .pipe(takeUntil(this.destroy$))
          .subscribe((ev) => {
            if (ev.key === 'Shift') {
              this._shiftPressed = false;
              this._clearShiftSiblingsHighlight();
              this._hideHoverTooltip();
              this._triggerSyntheticHover(false);
            }
          })
      );
    }

    this.zoomService.zoomChange$
      .pipe(
        // Debounce to prevent too many updates during continuous zoom
        debounceTime(16), // roughly 60fps
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.updateFocusNodePos();
        this.updateMultiFocusNodePositions();
      });
  }

  onInit(el: any) {
    this.$$canvas = el;
    $focusNode = $('.wm-focus-rect');
    this.ngZone.runOutsideAngular(() => {
      this.defineDnd();
    });
    runtimeEventManager.on('widget-name').subscribe((nv: string) => this.updateFocusNodePos());
    runtimeEventManager.on('add-autolayout').subscribe(() => {
      this.applyAutoLayout();
    });

    this.$$canvas.off('selection');
    this.attachMouseEvents();

    this.$$canvas?.off('.canvas-dom').on('click.canvas-dom', this.clickHandler.bind(this) as JQuery.EventHandler<HTMLElement>);

    // Focus on root on page ready
    const initiailWidgetId = this.markupManager?.getMarkup()?.children().first().attr('widget-id');
    $widget = this.$$canvas?.find("[widget-id=" + initiailWidgetId + "]");
    if($widget){
      this.updateFocusNodePos();
      $focusNode?.removeClass('ng-hide');
    }

  }

  getWidgetFromWidgetId(widgetId: string) {
    return this.$$canvas?.find('[widget-id="' + widgetId + '"]');
  }

  getClosestWidget(e: ClickEvent) {
    let target = e.target;
    if (target.tagName.startsWith('WM-DYNAMIC-COMPONENT')) {
      target = target.firstChild;
    }
    return target && $(target).closest('[widget-id]');
  }

  isDialogType(el: HTMLElement) {
    let attrs = ['wmdialog', 'wmalertdialog', 'wmconfirmdialog', 'wmiframedialog', 'wmpagedialog', 'wmlogindialog', 'wmbottomsheet'];
    return find(attrs, ((val: string) => {
      return el.hasAttribute(val)
    }));
  }

  getOverlayDim($el: JQuery<HTMLElement>): OverlayDimensions | undefined {
    if (!$el || !$el[0]) {
      return;
    }

    if (this.isDialogType($el[0])) {
      $el = $el.find('.dialog-view') || $el;
    }

    const zoomFactor = this.zoomService.zoomPercentage$.value / 100;

    // Using getClientRects() for more accurate current box model representation
    const clientRect = $el[0].getClientRects()[0];
    if (!clientRect) {
      return;
    }

    // Use position() for coordinates relative to offset parent
    const position = $el.position();

    // Get computed styles for precise margin calculations
    const computedStyle = window.getComputedStyle($el[0]);
    const marginTop = parseFloat(computedStyle.marginTop);
    const marginLeft = parseFloat(computedStyle.marginLeft);

    // Get parent and its scroll information
    const parent = $el.parent()[0] as HTMLElement;
    const parentScrollTop = parent ? parent.scrollTop : 0;
    const parentScrollLeft = parent ? parent.scrollLeft : 0;

    // Calculate actual dimensions and position considering zoom
    const overlay: OverlayDimensions = {
      width: clientRect.width / zoomFactor,
      height: clientRect.height / zoomFactor,
      top: (position.top / zoomFactor) + (parentScrollTop / zoomFactor) + (marginTop / zoomFactor),
      left: (position.left / zoomFactor) + (parentScrollLeft / zoomFactor) + (marginLeft / zoomFactor)
    };

    return overlay;
  }

  updateFocusNodePos() {
    if (!$widget || !$widget[0]) {
      return;
    }

    // Do not show the focus node if the widget is hidden in the canvas
    if ($widget.attr('hidden')) {
      $focusNode?.attr('hidden', 'true');
      return;
    }

    $focusNode?.removeAttr('hidden');
    // initially focusNode display is none for canvas dialog elements
    $focusNode?.css('display', 'inline-block');

    let pos = this.getOverlayDim($widget);

    if (pos && !isEqual(lastActiveWidPos, pos)) {
      $focusNode?.css(pos as any);
    }

    lastActiveWidPos = pos;
    $widget.after($focusNode);

    let name = get($widget[0], 'widget.name');
  }

  cleanupAddWidCancel() {
    addPosDetermined = false; // NO LONGER USED, BUT KEPT FOR COMPATIBILITY
    lastHoverWidId = undefined;
    action = undefined;
    addWidgetInfo = {};
    $focusNode?.removeClass('ng-hide');
    this.clearDropHighlight(); // CLEAR HIGHLIGHTS ON CANCEL
    isHighlighted = false;
    this.observeResizeObserver();
    this.hideTreeNode();
  }

  cleanupAddWidSuccess() {
    addPosDetermined = false; // NO LONGER USED
    lastHoverWidId = undefined;
    action = undefined;
    addWidgetInfo = {};
    $focusNode?.removeClass('ng-hide');
    this.clearDropHighlight(); // CLEAR HIGHLIGHTS ON SUCCESS
    isHighlighted = false;
    this.observeResizeObserver();
    this.hideTreeNode();
  }

  cleanupMoveWidCancel() {
    action = undefined;
    moveSuccess = false;
    movePosChanged = false; // NO LONGER USED
    lastHoverWidId = undefined;

    this.updateFocusNodePos();
    $widget.removeClass('drag-in-action');
    $focusNode?.removeClass('drag-in-action');
    // this.removeDropPreditionClsFromParent();
    this.clearDropHighlight(); // CLEAR HIGHLIGHTS ON CANCEL
    isHighlighted = false;
    this.observeResizeObserver();
    this.hideTreeNode();

    if ($widget && $widget.length) {
      this._removeMovingOverlayNode($widget);
      // remove drag preview if any
      this._removeDragPreview();
      // remove moving overlay from selection
      this._removeMovingOverlayFromSelection();
      // ensure focus node not draggable and toolbar hidden state cleared
      $focusNode?.removeAttr('draggable');
      $focusNode?.removeClass('no-toolbar');
    }
  }

  cleanupMoveWidSuccess() {
    action = undefined;
    moveSuccess = false;
    movePosChanged = false; // NO LONGER USED
    lastHoverWidId = undefined;

    this.updateFocusNodePos();
    $widget.removeClass('drag-in-action');
    $focusNode?.removeClass('drag-in-action');
    // this.removeDropPreditionClsFromParent();
    this.clearDropHighlight(); // CLEAR HIGHLIGHTS ON SUCCESS
    isHighlighted = false;
    this.observeResizeObserver();
    this.hideTreeNode();

    if ($widget && $widget.length) {
      this._removeMovingOverlayNode($widget);
      // remove drag preview if any
      this._removeDragPreview();
      // remove moving overlay from selection
      this._removeMovingOverlayFromSelection();
      // ensure focus node not draggable and toolbar hidden state cleared
      $focusNode?.removeAttr('draggable');
      $focusNode?.removeClass('no-toolbar');
    }
  }

  private attachMouseEvents() {
    this.$$canvas?.on('mousemove.selection', '[widgetid], [widget-id]', (e:any) => this._onCanvasMousemove(e));
    this.$$canvas?.on('mouseleave.selection', () => {
      this._onCanvasMouseLeave();
    });
  }

  private _onCanvasMouseLeave() {
    if (this._hoverRafId) {
      cancelAnimationFrame(this._hoverRafId);
      this._hoverRafId = null;
    }
    this._pendingMouseEvent = null;
    this._clearHoverVisuals();
    this._hideHoverTooltip();
    this._lastMouseClientX = null;
    this._lastMouseClientY = null;
  }

  private _getDataTransfer(ev: any): DataTransfer | undefined {
    if (!ev) { return undefined; }
    // If it's already a native DragEvent-like object
    if ((ev as DragEvent).dataTransfer) {
      return (ev as DragEvent).dataTransfer as DataTransfer;
    }
    // If it's a jQuery wrapper that stores the native event in originalEvent
    if (ev.originalEvent && (ev.originalEvent as DragEvent).dataTransfer) {
      return (ev.originalEvent as DragEvent).dataTransfer as DataTransfer;
    }
    // fallback: sometimes dataTransfer is available directly under the jQuery event object
    if ((ev as any).dataTransfer) {
      return (ev as any).dataTransfer as DataTransfer;
    }
    return undefined;
  }

  // Create the drag preview element (dark rectangle with icon + name) and set as drag image
  private _createDragPreview(widgetEl: HTMLElement | null) {
    this._removeDragPreview();

    if (!widgetEl) { return; }

    // derive widgetType and widgetSubType
    let widgetType = widgetEl.getAttribute('widgettype') || '';
    let widgetSubType = widgetEl.getAttribute('widget') || widgetEl.getAttribute('type') || '';
    widgetSubType = widgetSubType.replace('wm-', '').toLowerCase();
    let icon = widgetType.replace('wm-', '');

    if (widgetType === 'wm-chart') {
      icon = widgetSubType + icon;
    } else if (widgetType === 'wm-form-field' || widgetType === 'wm-filter-field') {
      icon = widgetSubType || 'text';
    }

    const iconClass = 'design-tool-icon wms wms-code-block wms-widget-' + icon;

    const name = (widgetEl.getAttribute('name') || '').toString();

    // build DOM
    const $preview = $('<div class="canvas-drag-preview" aria-hidden="true"></div>');
    const $inner = $('<div class="canvas-drag-preview-inner"></div>');
    const $icon = $(`<i class="${iconClass}"></i>`);
    const $text = $(`<span class="canvas-drag-preview-label"></span>`).text(name);

    $inner.append($icon).append($text);
    $preview.append($inner);
    this.$$canvas.append($preview);
    this._dragPreviewEl = $preview;
    return $preview;
  }

  private _removeDragPreview() {
    if (this._dragPreviewEl && this._dragPreviewEl.length) {
      this._dragPreviewEl.remove();
    }
    this._dragPreviewEl = null;
  }

  private _removeMovingOverlayFromSelection() {
    if (this.$selectedWidgets && this.$selectedWidgets.length) {
      this.$selectedWidgets.each((i, el) => {
        $(el).removeClass('moving-widget-overlay');
        this._removeMovingOverlayNode($(el));
      });
    }
    if ($widget && $widget.length) {
      $widget.removeClass('moving-widget-overlay'); this._removeMovingOverlayNode($widget);
    }
  }

  private _ensureMovingOverlayNode($w: JQuery<HTMLElement>) {
    if (!$w || !$w.length) { return; }
    // prevent duplicate
    if ($w.children('.moving-widget-overlay-node').length) { return; }

    // use a simple element so CSS can style it
    const $node = $('<div class="moving-widget-overlay-node"></div>');
    // optionally append a dotted-border child to avoid overlay covering border
    const $border = $('<div class="moving-widget-overlay-node __border"></div>');
    // append background node, and border node on top
    $w.css('position', function(i, v) {
      // ensure widget is positioned such that absolute child will align correctly
      // if already positioned (relative/absolute/fixed) keep it
      const pos = v || window.getComputedStyle($w[0]).position;
      return (pos && pos !== 'static') ? pos : 'relative';
    });
    $w.append($node);
    $w.append($border);
  }

  private _removeMovingOverlayNode($w: JQuery<HTMLElement>) {
    if (!$w || !$w.length) { return; }
    $w.children('.moving-widget-overlay-node').remove();
  }


  private _ensureDropElements() {
    if (!this._dropLineEl || !this._dropLineEl.length) {
      this._dropLineEl = $('<div class="drop-line" />').appendTo('body');
    }

    if (!this._dropLabelEl || !this._dropLabelEl.length) {
      this._dropLabelEl = $('<div class="drop-label" />').appendTo('body');
    }
  }

  private _hideDropLine() {
    if (this._dropLineEl && this._dropLineEl.length) {
      this._dropLineEl.hide();
    }
  }

  private _hideDropLabel() {
    if (this._dropLabelEl && this._dropLabelEl.length) {
      this._dropLabelEl.hide();
      this._currentLabelContainerId = null;
    }
  }

  private _showDropLineVertical(
    centerX: number,
    containerRect: DOMRect,
    lenOverride?: number,
    centerYOverride?: number,
    crossAxisAlign: 'center' | 'start' | 'end' = 'center'
  ) {
    this._ensureDropElements();

    const maxLen = this.DROP_LINE_MAX_LENGTH;
    const avail = Math.max(0, containerRect.height);

    let len: number;
    if (typeof lenOverride === 'number') {
      // Use provided override (typically MOVE-case).
      len = Math.round(lenOverride);

      // If item length >= available height, use 80% of available.
      if (len >= avail) {
        len = Math.round(avail * this.DROP_LINE_MIN_RATIO);
      }

      // Ensure it doesn't exceed container bounds.
      len = Math.min(len, avail);
    } else {
      // ADD/Default behavior: ratio of available, capped by maxLen
      len = Math.round(avail * this.DROP_LINE_MIN_RATIO);
      len = Math.min(len, avail);
      len = Math.min(len, maxLen);
    }

    // compute top: semantics vary by crossAxisAlign
    let top: number;
    if (typeof centerYOverride === 'number') {
      if (crossAxisAlign === 'center') {
        top = Math.round(centerYOverride - len / 2);
      } else if (crossAxisAlign === 'start') {
        top = Math.round(centerYOverride);
      } else { // 'end'
        top = Math.round(centerYOverride - len);
      }
    } else {
      top = Math.round((containerRect.top + containerRect.height / 2) - len / 2);
    }

    // clamp inside container vertical bounds
    const minTop = Math.round(containerRect.top);
    const maxTop = Math.round(containerRect.bottom - len);
    top = Math.max(minTop, Math.min(top, maxTop));

    const left = Math.round(centerX) - Math.round(this.DROP_LINE_WIDTH / 2);

    this._dropLineEl!.css({
      position: 'fixed',
      left: `${left}px`,
      top: `${top}px`,
      height: `${Math.round(len)}px`,
      width: `${this.DROP_LINE_WIDTH}px`,
      display: 'block',
      zIndex: 2147483646,
      pointerEvents: 'none',
      opacity: 1,
      background: '#1794EF',
      'border-radius': '5px'
    });
  }

  private _showDropLineHorizontal(
    centerY: number,
    containerRect: DOMRect,
    lenOverride?: number,
    centerXOverride?: number,
    crossAxisAlign: 'center' | 'start' | 'end' = 'center'
  ) {
    this._ensureDropElements();

    const maxLen = this.DROP_LINE_MAX_LENGTH;
    const avail = Math.max(0, containerRect.width);

    let len: number;
    if (typeof lenOverride === 'number') {
      // Use provided override (typically MOVE-case).
      len = Math.round(lenOverride);

      // If item length >= available width, use 80% of available.
      if (len >= avail) {
        len = Math.round(avail * this.DROP_LINE_MIN_RATIO);
      }

      // Ensure it doesn't exceed container bounds.
      len = Math.min(len, avail);
    } else {
      // ADD/Default behavior: ratio of available, capped by maxLen
      len = Math.round(avail * this.DROP_LINE_MIN_RATIO);
      len = Math.min(len, avail);
      len = Math.min(len, maxLen);
    }

    // compute left: semantics vary by crossAxisAlign
    let left: number;
    if (typeof centerXOverride === 'number') {
      if (crossAxisAlign === 'center') {
        left = Math.round(centerXOverride - len / 2);
      } else if (crossAxisAlign === 'start') {
        left = Math.round(centerXOverride);
      } else { // 'end'
        left = Math.round(centerXOverride - len);
      }
    } else {
      left = Math.round((containerRect.left + containerRect.width / 2) - len / 2);
    }

    // clamp inside container horizontal bounds
    const minLeft = Math.round(containerRect.left);
    const maxLeft = Math.round(containerRect.right - len);
    left = Math.max(minLeft, Math.min(left, maxLeft));

    const top = Math.round(centerY) - Math.round(this.DROP_LINE_WIDTH / 2);

    this._dropLineEl!.css({
      position: 'fixed',
      left: `${left}px`,
      top: `${top}px`,
      width: `${Math.round(len)}px`,
      height: `${this.DROP_LINE_WIDTH}px`,
      display: 'block',
      zIndex: 2147483646,
      pointerEvents: 'none',
      opacity: 1,
      background: 'rgb(1, 166, 216)',
      'border-radius': '5px'
    });
  }

  /**
   * Show the small name label for the container.
   */
  private _showContainerLabel($container: JQuery<HTMLElement>) {
    $container = $container.closest('[widget-id]');
    if (!($container && $container.length)) { return; }
    this._ensureDropElements();

    // reuse label if already shown for the same element
    const containerId = $container.attr('widget-id') || $container.attr('widgetid') || '';
    if (this._currentLabelContainerId === containerId) {
      this._dropLabelEl!.show();
      return;
    }

    const name = $container.attr('name') || '';
    if (!name) {
      this._hideDropLabel();
      this._currentLabelContainerId = null;
      return;
    }

    const rect = $container[0].getBoundingClientRect();

    const paddingLeft = 0;
    const labelLeft = rect.left + paddingLeft;
    const labelTop = rect.top - this.DROP_LABEL_OFFSET;

    this._dropLabelEl!.text(name).css({
      position: 'fixed',
      left: `${Math.round(labelLeft)}px`,
      top: `${Math.round(labelTop - 1000)}px`,
      display: 'inline-block',
      zIndex: 2147483647,
      pointerEvents: 'none',
      background: '#1794EF',
      color: 'white',
      padding: '1px 5px',
      'font-size': 'smaller'
    }).show();

    // measure and position above container
    const labelRect = (this._dropLabelEl![0] as HTMLElement).getBoundingClientRect();
    const finalTop = Math.max(rect.top - labelRect.height - this.DROP_LABEL_OFFSET, 4); // ensure not offscreen too high
    this._dropLabelEl!.css({
      left: `${Math.round(labelLeft)}px`,
      top: `${Math.round(finalTop)}px`
    });

    this._currentLabelContainerId = containerId;
  }

  /** hide both visual elements */
  private _hideDropVisuals() {
    this._hideDropLine();
    this._hideDropLabel();
    this.pageStructureService.hideTreeNodePreview()
  }

  private updateDropHighlightInContainer($container: JQuery<HTMLElement> | null, e: any) {
    if (!$container || !$container.length) {
      this.clearDropHighlight();
      return;
    }

    const direction = $container.attr('direction');
    const isRow = direction ? direction === 'row' : true;
    const isColumn = direction ? direction === 'column' : false;

    const containerRect = $container[0].getBoundingClientRect();

    const $children = $container.children('[widget-id]');
    const children = $children.toArray() as HTMLElement[];

    const EDGE_GAP = 2; // px

    const draggedRect: DOMRect | null = ($widget && $widget.length) ? $widget[0].getBoundingClientRect() : null;

    // if container has no direction OR row with wrap attribute -> use flow-aware handler
    const wrapAttr = ($container.attr('wrap') ?? $container.css('flexWrap')) as string | undefined;
    const isWrapMode = isRow && !!wrapAttr && (wrapAttr === 'true' || wrapAttr === 'wrap');
    const isFlowMode = !direction || isWrapMode;

    if (isFlowMode) {
      this.updateDropHighlightForFlowContainer($container, e, children, containerRect, draggedRect, isWrapMode);
      return;
    }

    // no children -> show container inside
    if (children.length === 0) {
      // only update if something changed
      if (currentHighlightTarget?.[0] === $container[0] && currentHighlightSide === 'inside' && currentHighlightParent?.[0] === $container[0]) {
        this.treeNodeHighlight($container, 'nochildren')
        return;
      }

      this.clearDropHighlight();

      // Mark container as highlighted (dotted)
      $container.addClass('drop-highlight-container');
      $container.addClass('drop-highlight-inside');
      this._showContainerLabel($container);

      currentHighlightParent = $container;
      currentHighlightTarget = $container;
      currentHighlightSide = 'inside';
      isHighlighted = true;

      const alignmentAttr = ($container.attr('alignment') ?? '').toString().trim();
      const hasAlignment = !!alignmentAttr;
      const alignment = hasAlignment ? alignmentAttr.toLowerCase() : '';

      if (isRow) {
        const startX = containerRect.left + EDGE_GAP;
        let centerY: number | undefined;
        if (hasAlignment) {
          if (alignment.includes('top') || alignment.includes('start')) {
            centerY = containerRect.top;
          } else if (alignment.includes('middle') || alignment.includes('center')) {
            centerY = (containerRect.top + containerRect.bottom) / 2;
          } else if (alignment.includes('bottom') || alignment.includes('end')) {
            centerY = containerRect.bottom;
          } else {
            centerY = (containerRect.top + containerRect.bottom) / 2;
          }
        } else {
          centerY = (containerRect.top + containerRect.bottom) / 2;
        }

        if (action === ACTIONS.MOVE && draggedRect) {
          const itemLen = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
          this._showDropLineVertical(startX, containerRect, itemLen, centerY);
        } else {
          this._showDropLineVertical(startX, containerRect, undefined, centerY);
        }
        this.treeNodeHighlight($container, 'vertical')
      } else if (isColumn) {
        const startY = containerRect.top + EDGE_GAP;
        let centerX: number | undefined;
        if (hasAlignment) {
          if (alignment.includes('left') || alignment.includes('start')) {
            centerX = containerRect.left;
          } else if (alignment.includes('center') || alignment.includes('middle')) {
            centerX = (containerRect.left + containerRect.right) / 2;
          } else if (alignment.includes('right') || alignment.includes('end')) {
            centerX = containerRect.right;
          } else {
            centerX = (containerRect.left + containerRect.right) / 2;
          }
        } else {
          centerX = (containerRect.left + containerRect.right) / 2;
        }

        if (action === ACTIONS.MOVE && draggedRect) {
          const itemLen = Math.round(draggedRect.width * this.DROP_LINE_MIN_RATIO);
          this._showDropLineHorizontal(startY, containerRect, itemLen, centerX);
        } else {
          this._showDropLineHorizontal(startY, containerRect, undefined, centerX);
        }
        this.treeNodeHighlight($container, 'horizontal')
      } else {
        const centerX = (containerRect.left + containerRect.right) / 2;
        const centerY = (containerRect.top + containerRect.bottom) / 2;
        this._showDropLineVertical(centerX, containerRect, undefined, centerY);
        this.treeNodeHighlight($container, 'vertical')
      }

      return;
    }

    // sort children by main axis
    if (isRow) {
      children.sort((a, b) => a.getBoundingClientRect().left - b.getBoundingClientRect().left);
    } else {
      children.sort((a, b) => a.getBoundingClientRect().top - b.getBoundingClientRect().top);
    }

    const clientPos = isRow ? e.clientX : e.clientY;

    // find insertion index (first child whose center is greater than clientPos)
    let insertIndex = children.length;
    for (let i = 0; i < children.length; i++) {
      const rect = children[i].getBoundingClientRect();
      const center = isRow ? (rect.left + rect.width / 2) : (rect.top + rect.height / 2);
      if (clientPos < center) {
        insertIndex = i;
        break;
      }
    }

    // Determine prev/next rects for midpoint calculation
    const prevRect = insertIndex - 1 >= 0 ? children[insertIndex - 1].getBoundingClientRect() : null;
    const nextRect = insertIndex < children.length ? children[insertIndex].getBoundingClientRect() : null;

    // Decide reference element and side
    let $refEl: JQuery<HTMLElement> | null = null;
    let side: 'left' | 'right' | 'top' | 'bottom' | null = null;

    if (insertIndex === children.length) {
      // append after last child
      const lastChild = children[children.length - 1];
      $refEl = $(lastChild);
      side = isRow ? 'right' : 'bottom';
    } else {
      const nextChild = children[insertIndex];
      $refEl = $(nextChild);
      side = isRow ? 'left' : 'top';
    }

    let lineX: number | null = null;
    let lineY: number | null = null;
    let lenOverride: number | undefined = undefined;
    let centerCrossAxisOverride: number | undefined = undefined;
    let crossAxisAlign: 'center' | 'start' | 'end' = 'center';

    // read alignment once
    const alignmentAttr = ($container.attr('alignment') ?? '').toString().trim();
    const hasAlignment = !!alignmentAttr;
    const alignment = hasAlignment ? alignmentAttr.toLowerCase() : '';

    if (isRow) {
      if (prevRect && nextRect) {
        lineX = (prevRect.right + nextRect.left) / 2;

        if (action === ACTIONS.MOVE && draggedRect) {
          lenOverride = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
        } else {
          const biggestSiblingHeight = children.reduce((acc, ch) => {
            const r = ch.getBoundingClientRect();
            return Math.max(acc, r.height);
          }, 0);
          lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, biggestSiblingHeight * this.DROP_LINE_MIN_RATIO));
        }

        if (hasAlignment) {
          if (alignment.includes('top') || alignment.includes('start')) {
            centerCrossAxisOverride = containerRect.top;
            crossAxisAlign = 'start';
          } else if (alignment.includes('middle') || alignment.includes('center')) {
            centerCrossAxisOverride = (prevRect.height >= nextRect.height)
              ? (prevRect.top + prevRect.bottom) / 2
              : (nextRect.top + nextRect.bottom) / 2;
            crossAxisAlign = 'center';
          } else if (alignment.includes('bottom') || alignment.includes('end')) {
            centerCrossAxisOverride = containerRect.bottom;
            crossAxisAlign = 'end';
          } else {
            centerCrossAxisOverride = (prevRect.top + prevRect.bottom) / 2;
            crossAxisAlign = 'center';
          }
        } else {
          centerCrossAxisOverride = (prevRect.height >= nextRect.height)
            ? (prevRect.top + prevRect.bottom) / 2
            : (nextRect.top + nextRect.bottom) / 2;
          crossAxisAlign = 'center';
        }
      } else if (nextRect && !prevRect) {
        lineX = Math.max(containerRect.left, nextRect.left - this.DROP_LINE_WIDTH * 2);
        if (action === ACTIONS.MOVE && draggedRect) {
          lenOverride = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
        } else {
          lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, nextRect.height * this.DROP_LINE_MIN_RATIO));
        }

        if (hasAlignment) {
          if (alignment.includes('top') || alignment.includes('start')) {
            centerCrossAxisOverride = containerRect.top; crossAxisAlign = 'start';
          } else if (alignment.includes('middle') || alignment.includes('center')) {
            centerCrossAxisOverride = (nextRect.top + nextRect.bottom) / 2; crossAxisAlign = 'center';
          } else if (alignment.includes('bottom') || alignment.includes('end')) {
            centerCrossAxisOverride = containerRect.bottom; crossAxisAlign = 'end';
          } else {
            centerCrossAxisOverride = (nextRect.top + nextRect.bottom) / 2; crossAxisAlign = 'center';
          }
        } else {
          centerCrossAxisOverride = (nextRect.top + nextRect.bottom) / 2; crossAxisAlign = 'center';
        }
      } else if (prevRect && !nextRect) {
        lineX = Math.min(containerRect.right, prevRect.right + this.DROP_LINE_WIDTH * 2);
        if (action === ACTIONS.MOVE && draggedRect) {
          lenOverride = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
        } else {
          lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, prevRect.height * this.DROP_LINE_MIN_RATIO));
        }

        if (hasAlignment) {
          if (alignment.includes('top') || alignment.includes('start')) {
            centerCrossAxisOverride = containerRect.top; crossAxisAlign = 'start';
          } else if (alignment.includes('middle') || alignment.includes('center')) {
            centerCrossAxisOverride = (prevRect.top + prevRect.bottom) / 2; crossAxisAlign = 'center';
          } else if (alignment.includes('bottom') || alignment.includes('end')) {
            centerCrossAxisOverride = containerRect.bottom; crossAxisAlign = 'end';
          } else {
            centerCrossAxisOverride = (prevRect.top + prevRect.bottom) / 2; crossAxisAlign = 'center';
          }
        } else {
          centerCrossAxisOverride = (prevRect.top + prevRect.bottom) / 2; crossAxisAlign = 'center';
        }
      } else {
        lineX = (containerRect.left + containerRect.right) / 2;
        lenOverride = this.DROP_LINE_MAX_LENGTH;
        centerCrossAxisOverride = (containerRect.top + containerRect.bottom) / 2;
        crossAxisAlign = 'center';
      }
    } else if (isColumn) {
      if (prevRect && nextRect) {
        lineY = (prevRect.bottom + nextRect.top) / 2;

        if (action === ACTIONS.MOVE && draggedRect) {
          lenOverride = Math.round(draggedRect.width * this.DROP_LINE_MIN_RATIO);
        } else {
          const biggestSiblingWidth = children.reduce((acc, ch) => {
            const r = ch.getBoundingClientRect();
            return Math.max(acc, r.width);
          }, 0);
          lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, biggestSiblingWidth * this.DROP_LINE_MIN_RATIO));
        }

        if (hasAlignment) {
          if (alignment.includes('left') || alignment.includes('start')) {
            centerCrossAxisOverride = containerRect.left; crossAxisAlign = 'start';
          } else if (alignment.includes('center') || alignment.includes('middle')) {
            centerCrossAxisOverride = (prevRect.width >= nextRect.width)
              ? (prevRect.left + prevRect.right) / 2
              : (nextRect.left + nextRect.right) / 2;
            crossAxisAlign = 'center';
          } else if (alignment.includes('right') || alignment.includes('end')) {
            centerCrossAxisOverride = containerRect.right; crossAxisAlign = 'end';
          } else {
            centerCrossAxisOverride = (prevRect.left + prevRect.right) / 2; crossAxisAlign = 'center';
          }
        } else {
          centerCrossAxisOverride = (prevRect.left + prevRect.right) / 2;
          crossAxisAlign = 'center';
        }
      } else if (nextRect && !prevRect) {
        lineY = Math.max(containerRect.top, nextRect.top - this.DROP_LINE_WIDTH * 2);
        if (action === ACTIONS.MOVE && draggedRect) {
          lenOverride = Math.round(draggedRect.width * this.DROP_LINE_MIN_RATIO);
        } else {
          lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, nextRect.width * this.DROP_LINE_MIN_RATIO));
        }

        if (hasAlignment) {
          if (alignment.includes('left') || alignment.includes('start')) {
            centerCrossAxisOverride = containerRect.left; crossAxisAlign = 'start';
          } else if (alignment.includes('center') || alignment.includes('middle')) {
            centerCrossAxisOverride = (nextRect.left + nextRect.right) / 2; crossAxisAlign = 'center';
          } else if (alignment.includes('right') || alignment.includes('end')) {
            centerCrossAxisOverride = containerRect.right; crossAxisAlign = 'end';
          } else {
            centerCrossAxisOverride = (nextRect.left + nextRect.right) / 2; crossAxisAlign = 'center';
          }
        } else {
          centerCrossAxisOverride = (nextRect.left + nextRect.right) / 2; crossAxisAlign = 'center';
        }
      } else if (prevRect && !nextRect) {
        lineY = Math.min(containerRect.bottom, prevRect.bottom + this.DROP_LINE_WIDTH * 2);
        if (action === ACTIONS.MOVE && draggedRect) {
          lenOverride = Math.round(draggedRect.width * this.DROP_LINE_MIN_RATIO);
        } else {
          lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, prevRect.width * this.DROP_LINE_MIN_RATIO));
        }

        if (hasAlignment) {
          if (alignment.includes('left') || alignment.includes('start')) {
            centerCrossAxisOverride = containerRect.left; crossAxisAlign = 'start';
          } else if (alignment.includes('center') || alignment.includes('middle')) {
            centerCrossAxisOverride = (prevRect.left + prevRect.right) / 2; crossAxisAlign = 'center';
          } else if (alignment.includes('right') || alignment.includes('end')) {
            centerCrossAxisOverride = containerRect.right; crossAxisAlign = 'end';
          } else {
            centerCrossAxisOverride = (prevRect.left + prevRect.right) / 2; crossAxisAlign = 'center';
          }
        } else {
          centerCrossAxisOverride = (prevRect.left + prevRect.right) / 2; crossAxisAlign = 'center';
        }
      } else {
        lineY = (containerRect.top + containerRect.bottom) / 2;
        lenOverride = this.DROP_LINE_MAX_LENGTH;
        centerCrossAxisOverride = (containerRect.left + containerRect.right) / 2;
        crossAxisAlign = 'center';
      }
    } else {
      this.clearDropHighlight();
      $container.addClass('drop-highlight-container');
      $container.addClass('drop-highlight-inside');
      this._showContainerLabel($container);
      currentHighlightParent = $container;
      currentHighlightTarget = $container;
      currentHighlightSide = 'inside';
      isHighlighted = true;
      return;
    }

    // Avoid unnecessary DOM updates if nothing changed
    if ($refEl && currentHighlightTarget && currentHighlightTarget.length &&
        currentHighlightTarget[0] === $refEl[0] && currentHighlightSide === side &&
        currentHighlightParent && currentHighlightParent.length && currentHighlightParent[0] === $container[0]) {
      if (isRow && lineX != null) {
        this._showDropLineVertical(lineX, containerRect, lenOverride, centerCrossAxisOverride, crossAxisAlign);
        this.treeNodeHighlight($container, 'vertical', side, $refEl)
      } else if (isColumn && lineY != null) {
        this._showDropLineHorizontal(lineY, containerRect, lenOverride, centerCrossAxisOverride, crossAxisAlign);
        this.treeNodeHighlight($container, 'horizontal', side, $refEl)
      }
      return;
    }

    // Clear previous visual states and set new ones
    this.clearDropHighlight();

    $container.addClass('drop-highlight-container');
    this._showContainerLabel($container);
    currentHighlightParent = $container;

    currentHighlightTarget = $refEl;
    currentHighlightSide = side;
    isHighlighted = true;

    if (isRow && lineX != null) {
      this._showDropLineVertical(lineX, containerRect, lenOverride, centerCrossAxisOverride, crossAxisAlign);
      this.treeNodeHighlight($container, 'vertical', side, $refEl)
    } else if (isColumn && lineY != null) {
      this._showDropLineHorizontal(lineY, containerRect, lenOverride, centerCrossAxisOverride, crossAxisAlign);
      this.treeNodeHighlight($container, 'horizontal', side, $refEl)
    }
  }



  private _isCandidateInline(
    $container: JQuery<HTMLElement>,
    refEl: JQuery<HTMLElement> | null,
    childRects: Array<{ el: HTMLElement, rect: DOMRect }>,
    isWrapMode: boolean
  ): boolean {
    // compute candidate element's computed display — keep for fallback
    let candidateDisplay: string | null = null;
    if (refEl && refEl.length) {
      candidateDisplay = window.getComputedStyle(refEl.get(0) as HTMLElement).display || null;
    }

    const inlineSet = new Set(['inline', 'inline-block', 'inline-flex', 'inline-grid']);

    // Quick detectors for ambiguous cases
    const anyChildAbsolute = childRects.some(c =>
      ((window.getComputedStyle(c.el as HTMLElement).position || '').toLowerCase() === 'absolute')
    );

    const hasFlexibleChildren = childRects.some(c => {
      const s = window.getComputedStyle(c.el as HTMLElement);
      return (parseFloat(s.flexGrow || '0') !== 0) || (parseFloat(s.flexShrink || '0') !== 0);
    });

    let candidateIsInline: boolean;

    try {
      const parentEl = $container.get(0) as HTMLElement | undefined;
      const parentStyle = parentEl ? window.getComputedStyle(parentEl) : null;

      if (parentStyle) {
        const parentDisplay = (parentStyle.display || '').toLowerCase();

        // FLEX containers
        if (parentDisplay === 'flex' || parentDisplay === 'inline-flex') {
          const flexDir = (parentStyle.flexDirection || 'row').toLowerCase();
          const flexWrap = (parentStyle.flexWrap || 'nowrap').toLowerCase();

          // row + nowrap => everything stays inline
          if (flexDir.startsWith('row') && flexWrap === 'nowrap') {
            candidateIsInline = true;
          }
          // row + wrap => if currently single visual row and no flexible/abs positioned children -> inline
          else if (flexDir.startsWith('row') && flexWrap !== 'nowrap') {
            if (childRects.length > 0 && !hasFlexibleChildren && !anyChildAbsolute) {
              candidateIsInline = true;
            } else {
              candidateIsInline = candidateDisplay ? inlineSet.has(candidateDisplay) : false;
            }
          } else {
            // flex column etc -> stacked vertically
            candidateIsInline = false;
          }
        }
        // GRID containers
        else if (parentDisplay === 'grid' || parentDisplay === 'inline-grid') {
          const gridFlow = (parentStyle.gridAutoFlow || '').toLowerCase();
          // grid auto-flow row-ish -> if no flexible/abs children treat as inline else fallback
          if (gridFlow.includes('row') && !hasFlexibleChildren && !anyChildAbsolute) {
            candidateIsInline = true;
          } else {
            candidateIsInline = candidateDisplay ? inlineSet.has(candidateDisplay) : false;
          }
        }
        // Other containers: default to candidate's display
        else {
          candidateIsInline = candidateDisplay ? inlineSet.has(candidateDisplay) : false;
        }
      } else {
        candidateIsInline = candidateDisplay ? inlineSet.has(candidateDisplay) : false;
      }
    } catch (err) {
      candidateIsInline = candidateDisplay ? inlineSet.has(candidateDisplay) : false;
    }

    if (isWrapMode) {
      candidateIsInline = true;
    }

    return candidateIsInline;
  }


  private updateDropHighlightForFlowContainer(
    $container: JQuery<HTMLElement>,
    e: any,
    children: HTMLElement[],
    containerRect: DOMRect,
    draggedRect: DOMRect | null,
    isWrapMode: boolean
  ) {
    if (!children || children.length === 0) {
      this.clearDropHighlight();
      $container.addClass('drop-highlight-container');
      $container.addClass('drop-highlight-inside');
      this._showContainerLabel($container);
      currentHighlightParent = $container;
      currentHighlightTarget = $container;
      currentHighlightSide = 'inside';
      isHighlighted = true;

      // alignment handling for empty flow container: follow alignment if present, else start
      const alignmentAttr = ($container.attr('alignment') ?? '').toString().trim();
      const hasAlignment = !!alignmentAttr;
      const alignment = hasAlignment ? alignmentAttr.toLowerCase() : '';

      const startX = containerRect.left + 2;
      let centerY: number;
      if (hasAlignment) {
        if (alignment.includes('top') || alignment.includes('start')) {
          centerY = containerRect.top;
        } else if (alignment.includes('middle') || alignment.includes('center')) {
          centerY = Math.round((containerRect.top + containerRect.bottom) / 2);
        } else if (alignment.includes('bottom') || alignment.includes('end')) {
          centerY = containerRect.bottom;
        } else {
          centerY = containerRect.top; // default start
        }
      } else {
        centerY = containerRect.top; // flow default -> start
      }

      if (action === ACTIONS.MOVE && draggedRect) {
        const itemLen = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
        this._showDropLineVertical(startX, containerRect, itemLen, centerY, hasAlignment ? (alignment.includes('top') || alignment.includes('start') ? 'start' : (alignment.includes('middle') || alignment.includes('center') ? 'center' : 'end')) : 'start');
      } else {
        this._showDropLineVertical(startX, containerRect, undefined, centerY, hasAlignment ? (alignment.includes('top') || alignment.includes('start') ? 'start' : (alignment.includes('middle') || alignment.includes('center') ? 'center' : 'end')) : 'start');
      }
      this.treeNodeHighlight($container, 'nochildren')
      return;
    }

    // compute child rects and rows
    const childRectsMap: Record<string, number> = {};
    const childRects = children.map((ch, idx) => { 
      const $el = $(ch);
      const id = $el.attr('widget-id') || $el.attr('widgetid');
      if(id) {
        childRectsMap[id] = idx;
      }
      return ({ el: ch, rect: ch.getBoundingClientRect() }) 
    });
    const rows = this.groupChildrenIntoRows(childRects);

    const clientX = e.clientX ?? (e.pageX ?? 0);
    const clientY = e.clientY ?? (e.pageY ?? 0);

    // pick row under pointer (or next-below or last)
    let rowIdx = -1;
    for (let i = 0; i < rows.length; i++) {
      if (clientY >= rows[i].top - this.ROW_OVERLAP_TOLERANCE && clientY <= rows[i].bottom + this.ROW_OVERLAP_TOLERANCE) {
        rowIdx = i;
        break;
      }
    }
    if (rowIdx === -1) {
      const nextBelow = rows.findIndex((r) => r.top > clientY);
      rowIdx = nextBelow !== -1 ? nextBelow : (rows.length - 1);
    }

    const targetRow = rows[rowIdx];

    // order items left->right
    const ordered = targetRow.items.slice().sort((a, b) => a.rect.left - b.rect.left);

    // find insertIndex by comparing clientX to centers of items
    let insertIndex = ordered.length;
    for (let i = 0; i < ordered.length; i++) {
      const centerX = ordered[i].rect.left + ordered[i].rect.width / 2;
      if (clientX < centerX) {
        insertIndex = i;
        break;
      }
    }

    // candidate anchor element
    let refEl: JQuery<HTMLElement> | null = null;
    if (insertIndex === ordered.length) {
      refEl = $(ordered[ordered.length - 1].el);
    } else {
      refEl = $(ordered[insertIndex].el);
    }

    const alignmentAttr = ($container.attr('alignment') ?? '').toString().trim();
    const hasAlignment = !!alignmentAttr;
    const alignment = hasAlignment ? alignmentAttr.toLowerCase() : '';

    const childRectsForHelper = childRects;
    const candidateIsInline = this._isCandidateInline($container, refEl, childRectsForHelper, isWrapMode);

    // ---------- INLINE CASE (vertical drop line between siblings) ----------
    if (candidateIsInline) {
      // compute xCoord and the item rect we will use for cross-axis anchor
      let currentPosRect: DOMRect;
      let xCoord: number;
      if (insertIndex === 0) {
        currentPosRect = ordered[0].rect;
        xCoord = Math.max(containerRect.left, ordered[0].rect.left - this.DROP_LINE_WIDTH * 2);
      } else if (insertIndex === ordered.length) {
        currentPosRect = ordered[ordered.length - 1].rect;
        xCoord = Math.min(containerRect.right, currentPosRect.right + this.DROP_LINE_WIDTH * 2);
      } else {
        const prev = ordered[insertIndex - 1].rect;
        currentPosRect = ordered[insertIndex].rect;
        xCoord = (prev.right + currentPosRect.left) / 2;
      }

      // decide cross-axis anchor based on alignment if present, else start (top)
      let crossCenterValue: number;
      let crossAxisAlign: 'center' | 'start' | 'end';
      if (hasAlignment) {
        if (alignment.includes('top') || alignment.includes('start')) {
          crossCenterValue = Math.round(currentPosRect.top);
          crossAxisAlign = 'start';
        } else if (alignment.includes('middle') || alignment.includes('center')) {
          crossCenterValue = Math.round((currentPosRect.top + currentPosRect.bottom) / 2);
          crossAxisAlign = 'center';
        } else if (alignment.includes('bottom') || alignment.includes('end')) {
          crossCenterValue = Math.round(currentPosRect.bottom);
          crossAxisAlign = 'end';
        } else {
          crossCenterValue = Math.round((currentPosRect.top + currentPosRect.bottom) / 2);
          crossAxisAlign = 'center';
        }
      } else {
        crossCenterValue = Math.round((currentPosRect.top + currentPosRect.bottom) / 2);
        crossAxisAlign = 'center';
      }

      // len override
      let lenOverride: number | undefined;
      if (action === ACTIONS.MOVE && draggedRect) {
        lenOverride = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
      } else {
        const biggestSiblingHeight = targetRow.items.reduce((acc, it) => Math.max(acc, it.rect.height), 0);
        lenOverride = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, biggestSiblingHeight * this.DROP_LINE_MIN_RATIO));
      }

      const side = (insertIndex === ordered.length) ? 'right' : 'left';
      if (refEl && currentHighlightTarget && currentHighlightTarget.length &&
          currentHighlightTarget[0] === refEl[0] && currentHighlightSide === side &&
          currentHighlightParent && currentHighlightParent.length && currentHighlightParent[0] === $container[0]) {
        this._showDropLineVertical(xCoord, containerRect, lenOverride, crossCenterValue, crossAxisAlign);
        this.treeNodeHighlight($container, 'vertical', side, refEl)
        return;
      }

      this.clearDropHighlight();
      $container.addClass('drop-highlight-container');
      this._showContainerLabel($container);
      currentHighlightParent = $container;
      currentHighlightTarget = refEl;
      currentHighlightSide = side as any;
      isHighlighted = true;

      this._showDropLineVertical(xCoord, containerRect, lenOverride, crossCenterValue, crossAxisAlign);
      this.treeNodeHighlight($container, 'vertical', side, refEl)
      return;
    }

    // ---------- NON-INLINE (horizontal new-row) ----------
    // Decide whether insertion is before or after row center
    const rowCenter = Math.round((targetRow.top + targetRow.bottom) / 2);
    const insertBefore = clientY < rowCenter;
    const side = insertBefore ? 'top' : 'bottom';
    const refForHorizontal = insertBefore ? $(ordered[0].el) : $(ordered[ordered.length - 1].el);

    // fallback horizontal insertion for flow-mode: anchor horizontal line to row.left by default,
    // but honor alignment if present (left/center/right).
    let centerXOverride: number;
    let crossAxisAlign: 'center'|'start'|'end';
    
    centerXOverride = Math.round(targetRow.left);
    crossAxisAlign = 'start';

    let lenOverrideHor: number | undefined;
    if (action === ACTIONS.MOVE && draggedRect) {
      lenOverrideHor = Math.round(draggedRect.width * this.DROP_LINE_MIN_RATIO);
    } else {
      lenOverrideHor = Math.min(this.DROP_LINE_MAX_LENGTH, Math.round(targetRow.right - targetRow.left) * this.DROP_LINE_MIN_RATIO);
    }

    const currentWidgetId = refEl.attr('widget-id') || refEl.attr('widgetid');
    let centerY;

    if(currentWidgetId) {
      let currIdx = childRectsMap[currentWidgetId];
      if(currIdx === childRects.length - 1) {
        if(insertBefore) {
          if(childRects.length === 1)
            centerY = childRects[currIdx].rect.top;
          else {
            const $prevEl = $(childRects[currIdx - 1].el);
            const isInline = this._isCandidateInline($container, $prevEl, childRectsForHelper, isWrapMode);
            if (!isInline) {
              centerY = (childRects[currIdx].rect.top + childRects[currIdx - 1].rect.bottom) / 2;
            } else {
              return this.showInlineDroplinePrev($container, containerRect, childRects, currIdx, draggedRect);
            }
          }
        } else {
          centerY = childRects[currIdx].rect.bottom;
        }
      } else if (currIdx === 0) {
        if(insertBefore) {
          centerY = childRects[0].rect.top;
        } else {
          if(childRects.length === 1)
            centerY = childRects[currIdx].rect.bottom;
          else {
            const $nextEl = $(childRects[currIdx + 1].el);
            const isInline = this._isCandidateInline($container, $nextEl, childRectsForHelper, isWrapMode);
            if (!isInline) {
              centerY = (childRects[currIdx].rect.bottom + childRects[currIdx + 1].rect.top) / 2;
            } else {
              return this.showInlineDroplineNext($container, containerRect, childRects, currIdx, draggedRect);
            }
          }
        }
      } else {
        // centerY = insertBefore ? (childRects[currIdx].rect.top + childRects[currIdx - 1].rect.bottom)/2 : 
        // (childRects[currIdx].rect.bottom + childRects[currIdx + 1].rect.top)/2;

        // if(insertBefore) {
        //   const $prevEl = $(childRects[currIdx - 1].el);
        //   const isInline = this._isCandidateInline($container, $prevEl, childRects, isWrapMode);
        //   if(!isInline) centerY = (childRects[currIdx].rect.top + childRects[currIdx - 1].rect.bottom)/2;
        //   else return;
        // } else {
        //   const $nextEl = $(childRects[currIdx + 1].el);
        //   const isInline = this._isCandidateInline($container, $nextEl, childRects, isWrapMode);
        //   if(!isInline) centerY = (childRects[currIdx].rect.bottom + childRects[currIdx + 1].rect.top)/2;
        //   else return;
        // }

        if (insertBefore) {
          const $prevEl = $(childRects[currIdx - 1].el);
          const isInline = this._isCandidateInline($container, $prevEl, childRectsForHelper, isWrapMode);
          if (!isInline) {
            centerY = (childRects[currIdx].rect.top + childRects[currIdx - 1].rect.bottom) / 2;
          } else {
            return this.showInlineDroplinePrev($container, containerRect, childRects, currIdx, draggedRect);
          }
        } else {
          const $nextEl = $(childRects[currIdx + 1].el);
          const isInline = this._isCandidateInline($container, $nextEl, childRectsForHelper, isWrapMode);
          if (!isInline) {
            centerY = (childRects[currIdx].rect.bottom + childRects[currIdx + 1].rect.top) / 2;
          } else {
            return this.showInlineDroplineNext($container, containerRect, childRects, currIdx, draggedRect);
          }
        }
      }
    } else {
      centerY = insertBefore ? targetRow.top : targetRow.bottom;
    }



    if (refForHorizontal && currentHighlightTarget && currentHighlightTarget.length &&
        currentHighlightTarget[0] === refForHorizontal[0] && currentHighlightSide === side &&
        currentHighlightParent && currentHighlightParent.length && currentHighlightParent[0] === $container[0]) {
      this._showDropLineHorizontal(centerY, containerRect, lenOverrideHor, centerXOverride, crossAxisAlign);
      this.treeNodeHighlight($container, 'horizontal', side, refEl)
      return;
    }

    this.clearDropHighlight();
    $container.addClass('drop-highlight-container');
    this._showContainerLabel($container);
    currentHighlightParent = $container;
    currentHighlightTarget = refForHorizontal;
    currentHighlightSide = side as any;
    isHighlighted = true;

    this._showDropLineHorizontal(centerY, containerRect, lenOverrideHor, centerXOverride, crossAxisAlign);
    this.treeNodeHighlight($container, 'horizontal', side, refEl)
  }

  private showInlineDroplineNext($container: JQuery<HTMLElement>, containerRect: DOMRect,
    childRects: {el: HTMLElement;rect: DOMRect;}[], currIdx: number, draggedRect: DOMRect | null) {
    const $nextEl = $(childRects[currIdx + 1].el);
    const alignmentAttr = ($container.attr('alignment') ?? '').toString().trim();
    const hasAlignment = !!alignmentAttr;
    const alignment = hasAlignment ? alignmentAttr.toLowerCase() : '';
    // show vertical line to the left of nextEl
    const nextRect = childRects[currIdx + 1].rect;
    const xCoord = Math.max(containerRect.left, nextRect.left - this.DROP_LINE_WIDTH * 2);

    // alignment-aware cross anchor on next
    let adjCrossCenter: number;
    if (hasAlignment) {
      if (alignment.includes('top') || alignment.includes('start')) adjCrossCenter = Math.round(nextRect.top);
      else if (alignment.includes('middle') || alignment.includes('center')) adjCrossCenter = Math.round((nextRect.top + nextRect.bottom) / 2);
      else if (alignment.includes('bottom') || alignment.includes('end')) adjCrossCenter = Math.round(nextRect.bottom);
      else adjCrossCenter = Math.round((nextRect.top + nextRect.bottom) / 2);
    } else {
      adjCrossCenter = Math.round((nextRect.top + nextRect.bottom) / 2);
    }

    let lenOverrideAdj: number | undefined;
    if (action === ACTIONS.MOVE && draggedRect) lenOverrideAdj = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
    else lenOverrideAdj = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, nextRect.height * this.DROP_LINE_MIN_RATIO));

    const ref = $nextEl;
    const sideAdj: 'left' = 'left';

    if (
      ref &&
      currentHighlightTarget &&
      currentHighlightTarget.length &&
      currentHighlightTarget[0] === ref[0] &&
      currentHighlightSide === sideAdj &&
      currentHighlightParent &&
      currentHighlightParent.length &&
      currentHighlightParent[0] === $container[0]
    ) {
      this._showDropLineVertical(xCoord, containerRect, lenOverrideAdj, adjCrossCenter);
      this.treeNodeHighlight($container, 'vertical')
      return;
    }

    this.clearDropHighlight();
    $container.addClass('drop-highlight-container');
    this._showContainerLabel($container);
    currentHighlightParent = $container;
    currentHighlightTarget = ref;
    currentHighlightSide = sideAdj as any;
    isHighlighted = true;

    this._showDropLineVertical(xCoord, containerRect, lenOverrideAdj, adjCrossCenter);
    this.treeNodeHighlight($container, 'vertical')
    return;
  }

  private showInlineDroplinePrev($container: JQuery<HTMLElement>, containerRect: DOMRect,
    childRects: {el: HTMLElement;rect: DOMRect;}[], currIdx: number, draggedRect: DOMRect | null) {
    const $prevEl = $(childRects[currIdx - 1].el);
    const alignmentAttr = ($container.attr('alignment') ?? '').toString().trim();
    const hasAlignment = !!alignmentAttr;
    const alignment = hasAlignment ? alignmentAttr.toLowerCase() : '';
    // show vertical line to the right of prevEl
    const prevRect = childRects[currIdx - 1].rect;
    const xCoord = Math.min(containerRect.right, prevRect.right + this.DROP_LINE_WIDTH * 2);

    // alignment-aware cross anchor on prev
    let adjCrossCenter: number;
    if (hasAlignment) {
      if (alignment.includes('top') || alignment.includes('start')) adjCrossCenter = Math.round(prevRect.top);
      else if (alignment.includes('middle') || alignment.includes('center')) adjCrossCenter = Math.round((prevRect.top + prevRect.bottom) / 2);
      else if (alignment.includes('bottom') || alignment.includes('end')) adjCrossCenter = Math.round(prevRect.bottom);
      else adjCrossCenter = Math.round((prevRect.top + prevRect.bottom) / 2);
    } else {
      adjCrossCenter = Math.round((prevRect.top + prevRect.bottom) / 2);
    }

    let lenOverrideAdj: number | undefined;
    if (action === ACTIONS.MOVE && draggedRect) lenOverrideAdj = Math.round(draggedRect.height * this.DROP_LINE_MIN_RATIO);
    else lenOverrideAdj = Math.round(Math.min(this.DROP_LINE_MAX_LENGTH, prevRect.height * this.DROP_LINE_MIN_RATIO));

    const ref = $prevEl;
    const sideAdj: 'right' = 'right';

    if (
      ref &&
      currentHighlightTarget &&
      currentHighlightTarget.length &&
      currentHighlightTarget[0] === ref[0] &&
      currentHighlightSide === sideAdj &&
      currentHighlightParent &&
      currentHighlightParent.length &&
      currentHighlightParent[0] === $container[0]
    ) {
      this._showDropLineVertical(xCoord, containerRect, lenOverrideAdj, adjCrossCenter);
      this.treeNodeHighlight($container, 'vertical')
      return;
    }

    this.clearDropHighlight();
    $container.addClass('drop-highlight-container');
    this._showContainerLabel($container);
    currentHighlightParent = $container;
    currentHighlightTarget = ref;
    currentHighlightSide = sideAdj as any;
    isHighlighted = true;

    this._showDropLineVertical(xCoord, containerRect, lenOverrideAdj, adjCrossCenter);
    this.treeNodeHighlight($container, 'vertical')
    return;
  }

  /**
   * Robust grouping into visual rows using meaningful overlap.
   * Returns rows: { items: [{el, rect}], top, bottom, left, right }
   */
  private groupChildrenIntoRows(childRects: Array<{ el: HTMLElement, rect: DOMRect }>) {
    // sort by top then left
    const sorted = childRects.slice().sort((a, b) => {
      if (Math.abs(a.rect.top - b.rect.top) > 1) return a.rect.top - b.rect.top;
      return a.rect.left - b.rect.left;
    });

    const rows: Array<{ items: Array<{el: HTMLElement, rect: DOMRect}>, top: number, bottom: number, left: number, right: number }> = [];

    for (const item of sorted) {
      const top = item.rect.top;
      const bottom = item.rect.bottom;
      const height = item.rect.height;

      let placed = false;

      for (const row of rows) {
        const rowTop = row.top;
        const rowBottom = row.bottom;
        const rowHeight = rowBottom - rowTop;

        // compute strict intersection
        const overlap = Math.min(bottom, rowBottom) - Math.max(top, rowTop);

        const minSize = Math.min(height, rowHeight);
        const requiredOverlap = Math.max(this.ROW_OVERLAP_MIN_PX, Math.round(minSize * this.ROW_OVERLAP_RATIO));

        if (overlap > requiredOverlap) {
          // same row
          row.items.push(item);
          row.top = Math.min(row.top, top);
          row.bottom = Math.max(row.bottom, bottom);
          row.left = Math.min(row.left, item.rect.left);
          row.right = Math.max(row.right, item.rect.right);
          placed = true;
          break;
        }

        // conservative fallback: if centers are extremely close (tiny rounding differences)
        const itemCenter = (top + bottom) / 2;
        const rowCenter = (rowTop + rowBottom) / 2;
        const allowedCenterDist = Math.max(1, Math.round(Math.max(rowHeight, height) * 0.12)); // conservative 12%
        if (Math.abs(itemCenter - rowCenter) <= allowedCenterDist) {
          row.items.push(item);
          row.top = Math.min(row.top, top);
          row.bottom = Math.max(row.bottom, bottom);
          row.left = Math.min(row.left, item.rect.left);
          row.right = Math.max(row.right, item.rect.right);
          placed = true;
          break;
        }
      }

      if (!placed) {
        rows.push({
          items: [item],
          top: top,
          bottom: bottom,
          left: item.rect.left,
          right: item.rect.right
        });
      }
    }

    return rows;
  }


  private _triggerSyntheticHover(shiftKey: boolean, target?: EventTarget | JQuery<HTMLElement> | null) {
    if (this._lastMouseClientX == null || this._lastMouseClientY == null) {
      return;
    }

    const tgt = target ?? this._lastHoverTarget;
    const syntheticEvent: any = {
      target: (tgt && (tgt as any).get ? (tgt as any).get(0) : tgt),
      clientX: this._lastMouseClientX,
      clientY: this._lastMouseClientY,
      shiftKey
    };

    // run hover processing immediately (manual trigger)
    this._processHoverEvent(syntheticEvent, true);
  }

  private _applyShiftSiblingsHighlight() {
    // only when a selection exists
    const selectionExists = (this.selectionSet && this.selectionSet.size > 0) || (this.$selectedWidgets && this.$selectedWidgets.length > 0);
    if (!selectionExists) {
      this._clearShiftSiblingsHighlight();
      return;
    }

    const $primary = ($widget && $widget.length) ? $widget : (this.$selectedWidgets && this.$selectedWidgets.length ? this.$selectedWidgets.eq(0) : null);
    if (!$primary || !$primary.length) { return; }

    // all widget children except those already selected (and not the primary)
    const $siblings = $primary?.parent().children('[widgetid], [widget-id]').filter((i: any, el: any) => {
      const $el = $(el);
      const id = $el.attr('widget-id') || $el.attr('widgetid');
      if (!id) { return false; }
      if (this.selectionSet && this.selectionSet.has(id)) { 
        $el.removeClass('hover-sibling hover-sibling-allowed'); 
        if($el.get(0) === this._lastValidHoverTarget?.get(0)) {
          $el.addClass('hover-highlight'); 
        }
        return false; 
      } // skip selected
      if($el.get(0) === this._lastValidHoverTarget?.get(0)) { this._lastValidHoverTarget?.addClass('hover-sibling-allowed') }
      return true;
    });

    if ($siblings.length) {
      $siblings.addClass('hover-sibling');
      this._shiftSiblingsCollection = $siblings;
    } else {
      this._shiftSiblingsCollection = null;
    }
  }

  private _clearShiftSiblingsHighlight() {
    if (this._shiftSiblingsCollection && this._shiftSiblingsCollection.length) {
      this._shiftSiblingsCollection.removeClass('hover-sibling');
      this._lastValidHoverTarget?.removeClass('hover-sibling-allowed').addClass('hover-highlight');
    }
    this._shiftSiblingsCollection = null;
  }

  
  /** Returns number of currently selected widgets */
  public getSelectionCount(): number {
    return this.selectionSet ? this.selectionSet.size : 0;
  }

  /** Returns whether the given widgetId is currently selected */
  public isWidgetSelected(widgetId?: string | null): boolean {
    if (!widgetId) { return false; }
    return this.selectionSet ? this.selectionSet.has(widgetId) : false;
  }

  /**
   * When selectionSet has exactly 2 items and clickedId is one of them,
   * returns the other widget-id (the one that will remain after removing clickedId).
   * Otherwise returns null.
   */
  public getRemainingWidgetIdAfterDeselection(clickedId?: string | null): string | null {
    if (!clickedId || !this.selectionSet || this.selectionSet.size !== 2) { return null; }
    if (!this.selectionSet.has(clickedId)) { return null; }
    for (const id of this.selectionSet) {
      if (id !== clickedId) { return id; }
    }
    return null;
  }

  private emitSelectionChange() {
    this.eventManager.emitWidgetSelectionCount(this.selectionSet.size);
  }

  /**
   * Throttle mousemove processing with rAF: store the latest event in _pendingMouseEvent and process once per frame.
   */
  private _onCanvasMousemove(e: any) {
    this._lastHoverShiftKey = !!e.shiftKey;
    this._pendingMouseEvent = e;

    if (this._hoverRafId) {
      return;
    }
    this._hoverRafId = requestAnimationFrame(() => {
      this._hoverRafId = null;
      const evt = this._pendingMouseEvent;
      this._pendingMouseEvent = null;
      this._processHoverEvent(evt);
    });
  }

  /**
   * Return true when the component should IGNORE (block) the click.
   * Logic:
   *  - only blocks when Shift is held and there is an existing selection,
   *  - and the clicked target is a widget that is NOT a sibling of the current primary.
   */
  public shouldIgnoreClick(e?: ClickEvent): boolean {
    const shift = !!(e && e.shiftKey);

    if (!shift) { return false; }

    const selectionExists = (this.selectionSet && this.selectionSet.size > 0) ||
                            (this.$selectedWidgets && this.$selectedWidgets.length > 0);
    if (!selectionExists) { return false; }

    let $target: JQuery<HTMLElement> | null = null;
    if (e && e.target) {
      $target = $(e.target).closest('[widgetid], [widget-id]');
    }

    if (!$target || !$target.length) { return false; }

    const $primary = ($widget && $widget.length) ? $widget :
                    (this.$selectedWidgets && this.$selectedWidgets.length ? this.$selectedWidgets.eq(0) : null);

    if (!$primary || !$primary.length) { return false; }

    return !this.areSiblings($primary, $target);
  }


  /**
   * Core hover logic
   * Simplified rules:
   *  - no modifier => .hover-highlight on the element under cursor.
   *  - SHIFT and NO selection => same as no modifier (hover-highlight).
   *  - SHIFT and SOME selection => only siblings of primary selection are allowed:
   *      - if hovered is sibling => .hover-sibling-allowed (purple)
   *      - else => show not-allowed cursor + floating tooltip "Multi-select works only for sibling widgets"
   */
  private _processHoverEvent(e: any, isManualTrigger: boolean = false) {
    const $target = $(e.target).closest('[widgetid], [widget-id]');

    this._lastMouseClientX = e.clientX ?? (e.originalEvent && e.originalEvent.clientX) ?? null;
    this._lastMouseClientY = e.clientY ?? (e.originalEvent && e.originalEvent.clientY) ?? null;

    if (!$target || !$target.length) {
      this._clearHoverVisuals();
      this._hideHoverTooltip();
      return;
    }

    this._lastHoverTarget = $target;

    if (!isManualTrigger && this._lastValidHoverTarget && this._lastValidHoverTarget.length && $target.length &&
        this._lastValidHoverTarget.get(0) === $target.get(0) &&
        this._lastHoverShiftKey === !!e.shiftKey) {
      return;
    }

    const shift = !!e.shiftKey;
    const selectionExists = (this.selectionSet && this.selectionSet.size > 0) || (this.$selectedWidgets && this.$selectedWidgets.length > 0);

    if (this.isPrism && shift && selectionExists) { // Handle multiselect autolayout only for prism projects
      let $primary = $widget && $widget.length ? $widget : (this.$selectedWidgets && this.$selectedWidgets.length ? this.$selectedWidgets.eq(0) : null);

      if (!$primary || !$primary.length) {
        this._clearHoverVisuals();
        $target.addClass('hover-highlight');
        this._hideHoverTooltip();
        return;
      }

      const isSibling = this.areSiblings($primary, $target);

      this._hideHoverTooltip();

      if (isSibling) {
        const widgetId = $target.attr('widget-id') || $target.attr('widgetid');
        const isAlreadySelected = (widgetId && this.selectionSet && this.selectionSet.has(widgetId)) ||
                                  (this.$selectedWidgets && this.$selectedWidgets.is($target));

        if (isAlreadySelected) {

          this._clearHoverVisuals();
          $target.addClass('hover-highlight');
          this._lastValidHoverTarget = $target;
          return;
        } 
        
        this._clearHoverVisuals();

        $target.addClass('hover-sibling-allowed');
        this._lastValidHoverTarget = $target;

        return;
      }
      
      this._clearHoverVisuals();
      this._showHoverTooltip(e, 'Multi-select works only for sibling widgets');
      document.body.style.cursor = 'not-allowed';
      return;
    }

    this._clearHoverVisuals();
    $target.addClass('hover-highlight');
    this._lastValidHoverTarget = $target;
    this._hideHoverTooltip();
  }

  /**
   * Remove only previous hover visual classes (cheap).
   */
  private _clearHoverVisuals() {
    if (this._lastValidHoverTarget && this._lastValidHoverTarget.length) {
      this._lastValidHoverTarget.removeClass('hover-highlight hover-allowed hover-sibling-allowed');
    }
    
    this._lastValidHoverTarget = null;
    this._hideHoverTooltip();
  }

  /**
   * Create and show the floating hover tooltip near the pointer.
   * This is minimal (non-interactive) and positioned fixed so it follows the cursor position passed via event.
   */
  private _showHoverTooltip(e: any, message: string) {
    if (!this._hoverTooltipEl || !this._hoverTooltipEl.length) {
      this._hoverTooltipEl = $('<div class="wm-hover-tooltip" />').text(message).appendTo('body');
    } else {
      this._hoverTooltipEl.text(message);
      this._hoverTooltipEl.appendTo('body'); // ensure on top of DOM
    }

    // position near cursor (avoid going off-screen)
    const offsetX = 12;
    const offsetY = 18;
    const clientX = e.clientX || (e.originalEvent && e.originalEvent.clientX) || 0;
    const clientY = e.clientY || (e.originalEvent && e.originalEvent.clientY) || 0;
    const tooltip = this._hoverTooltipEl;

    // compute position and clamp
    requestAnimationFrame(() => {
      tooltip.css({
        position: 'fixed',
        left: Math.min(window.innerWidth - 220, clientX + offsetX) + 'px',
        top: Math.min(window.innerHeight - 40, clientY + offsetY) + 'px',
        zIndex: 2147483647,
        pointerEvents: 'none'
      });
      tooltip.addClass('visible');
    });
  }

  /**
   * Hide and remove hover tooltip.
   */
  private _hideHoverTooltip() {
    if (this._hoverTooltipEl && this._hoverTooltipEl.length) {
      try {
        this._hoverTooltipEl.removeClass('visible');
        this._hoverTooltipEl.remove();
      } catch (e) { }
      this._hoverTooltipEl = null;
    }
    document.body.style.cursor = '';
  }


   /**
   * Clears the selection (removes active class and cloned focus nodes).
   */
  private clearSelection() {
    this.$selectedWidgets?.removeClass(CLASS.ACTIVE_WIDGET);
    this.$selectedWidgets = $();
    this.selectionSet.clear();
    this.removeAllMultiFocusNodes();
    this.emitSelectionChange();
    this._clearShiftSiblingsHighlight();
  }

  /**
   * Adds an element to selection and creates a cloned (visual-only) focus node for it
   * if it is not the primary widget ($widget).
   */
  private addToSelection($el: JQuery<HTMLElement>, createClone: boolean = true) {
    if (!$el || !$el.length) { return; }
    const id = $el.attr('widget-id');
    if (!id) { return; }
    if (!this.selectionSet.has(id)) {
      this.$selectedWidgets = this.$selectedWidgets.add($el);
      this.selectionSet.add(id);
      $el.addClass(CLASS.ACTIVE_WIDGET);
      // create a multi focus node clone for non-primary selections
      if (createClone && (!$widget || !$widget[0] || $widget[0] !== $el[0])) {
        this.createMultiFocusNodeFor($el);
      }
      if (this._shiftPressed) {
        this._applyShiftSiblingsHighlight();
      }
      this.emitSelectionChange();
    }
  }

  /**
   * Removes an element from the selection and removes its cloned focus node.
   */
  private removeFromSelection($el: JQuery<HTMLElement>) {
    if (!$el || !$el.length) { return; }
    const id = $el.attr('widget-id');
    if (!id) { return; }
    if (this.selectionSet.has(id)) {
      this.$selectedWidgets = this.$selectedWidgets.not('[widget-id="' + id + '"]');
      this.selectionSet.delete(id);
      $el.removeClass(CLASS.ACTIVE_WIDGET);
      this.removeMultiFocusNode(id);
      this.emitSelectionChange();
    }

    if (this._shiftPressed) {
      if ((this.selectionSet && this.selectionSet.size > 0) || (this.$selectedWidgets && this.$selectedWidgets.length > 0)) {
        this._applyShiftSiblingsHighlight();
      } else {
        this._clearShiftSiblingsHighlight();
      }
    }
  }

  /**
   * Add the clicked widget to selection only if primary ($widget) and clicked widget
   * share the same closest parent that has attribute 'widget-id' or 'widgetid'.
   * Returns true if added, false if not (caller may fallback).
   */
  private areSiblings($from: JQuery<HTMLElement>, $to: JQuery<HTMLElement>) {
    if (!$from?.length || !$to?.length) { return false; }

    const findClosestWidgetParent = ($el: JQuery<HTMLElement>) => {
      let $p = $el.parent();
      while ($p && $p.length) {
        if ($p.is('[widget-id]') || $p.is('[widgetid]')) {
          return $p;
        }
        $p = $p.parent();
      }
      return null;
    };

    const pFrom = findClosestWidgetParent($from);
    const pTo = findClosestWidgetParent($to);

    return !!(pFrom && pTo && pFrom[0] === pTo[0]);
  }

    /**
     * Create a lightweight cloned focus rect for a selected widget (visual-only).
     * Cloned nodes include a minimal toolbar (widget-name) but NOT interactive handles/events.
     * We store the widget element along with the clone in selectedFocusNodes to avoid DOM lookups.
     */
    private createMultiFocusNodeFor($widgetEl: JQuery<HTMLElement>) {
      if (!$focusNode || !$focusNode.length || !$widgetEl || !$widgetEl.length) { return; }
      const id = $widgetEl.attr('widget-id') || $widgetEl.attr('widgetid');
      const name = $widgetEl.attr('name') || '';
      if (!id || this.selectedFocusNodes.has(id)) { return; }

      const $clone = $('<div/>', { class: 'wm-focus-rect wm-focus-rect-multi' });

      $widgetEl.after($clone);

      this.selectedFocusNodes.set(id, { clone: $clone, widgetEl: $widgetEl });

      const pos = this.getOverlayDim($widgetEl);
      if (pos) {
        requestAnimationFrame(() => {
          $clone.css(pos as any);
        });
      }

    }

    private removeMultiFocusNode(id: string) {
      const entry = this.selectedFocusNodes.get(id);
      if (entry && entry.clone) {
        entry.clone.remove();
        this.selectedFocusNodes.delete(id);
      }
    }

    private removeAllMultiFocusNodes() {
      this.selectedFocusNodes.forEach((entry) => {
        entry.clone.remove();
      });
      this.selectedFocusNodes.clear();
    }

    private repositionClonesOptimized() {
      const entries: Array<{ clone: JQuery<HTMLElement>, pos: any }> = [];
      this.selectedFocusNodes.forEach((entry) => {
        try {
          const pos = this.getOverlayDim(entry.widgetEl);
          entries.push({ clone: entry.clone, pos });
        } catch (e) {}
      });

      requestAnimationFrame(() => {
        for (let i = 0; i < entries.length; i++) {
          const e = entries[i];
          if (e.pos) {
            e.clone.css(e.pos as any);
          }
        }
      });
    }

    private updateMultiFocusNodePositions() {
      this.repositionClonesOptimized();
    }

  /**
   * Wrap sibling widgets (widgetIds[]) into a new container widget (runtime-first).
   * - widgetIds: array of widget-id strings to be wrapped
   * - containerWidgetType: widget type to create (default: 'wm-container')
   */
  public applyAutoLayout() {
    const widgetIds = Array.from(this.selectionSet);
    const containerWidgetType = "wm-container";
    if (!Array.isArray(widgetIds) || widgetIds.length < 2) {
      this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], 'Select at least 2 sibling widgets to wrap.');
      return;
    }

    const $widgets = widgetIds.map(id => this.getWidgetFromWidgetId(id)).filter(Boolean) as JQuery<HTMLElement>[];
    if ($widgets.length !== widgetIds.length) {
      this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], 'Some selected widgets are not present in the canvas.');
      return;
    }

    // ensure siblings (same parent)
    const parent = $widgets[0].parent().closest('[widget-id], [widgetid]');
    for (let i = 1; i < $widgets.length; i++) {
      const p = $widgets[i].parent().closest('[widget-id], [widgetid]');
      if (!p || p[0] !== parent[0]) {
        this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], 'Selected widgets must be direct siblings (same parent).');
        return;
      }
    }

    // build index map to preserve order
    const parentChildren = this.$selectedWidgets;
    const childIndexMap: Map<HTMLElement, number> = new Map();
    parentChildren.each((i, el) => { childIndexMap.set(el as HTMLElement, i) });

    const selectedIndices = $widgets.map(w => childIndexMap.get(w[0]) ?? Infinity);
    const minIndex = Math.min(...selectedIndices);
    if (!isFinite(minIndex)) {
      this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], 'Could not determine insertion position.');
      return;
    }

    // choose reference point
    let referenceId: string | undefined;
    let referencePos: 'before' | 'after' | undefined;
    const prevEl = parentChildren[minIndex - 1];
    if (prevEl) {
      referenceId = $(prevEl).attr('widget-id') || $(prevEl).attr('widgetid');
      referencePos = 'after';
    } else {
      const nextEl = parentChildren[minIndex];
      if (nextEl) {
        referenceId = $(nextEl).attr('widget-id') || $(nextEl).attr('widgetid');
        referencePos = 'before';
      }
    }

    const parentId = parent.attr('widget-id') || parent.attr('widgetid');
    if (!parentId) {
      this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], 'Could not identify parent container.');
      return;
    }

    const containerConfig: any = {
      widgetType: containerWidgetType,
      parentId,
      referenceId,
      referencePos,
      widgetDefaults: JSON.stringify({ width: "hug", variant: "default"})
    };

    const orderedWidgetIds = Array.from(childIndexMap.keys())
      .sort((a, b) => (childIndexMap.get(a) ?? 0) - (childIndexMap.get(b) ?? 0))
      .map(el => $(el).attr('widget-id') || $(el).attr('widgetid'))
      .filter(Boolean) as string[];
    const data = {
      widgetIds: orderedWidgetIds,
      containerInfo: containerConfig
    }

    this.eventManager.emitApplyAutolayout(data);
  }

  clickHandler(e?: JQuery.ClickEvent, widgetId?: string) {
    let _w;
    let canvasEl = this.markupManager.getActiveCanvasEl();
    const attrVal = canvasEl?.attr('widget-id') || widgetId;

    if (!e) {
      if (attrVal) {
        _w = this.getWidgetFromWidgetId(attrVal);
        if (!_w || !_w.length) { return; }
        this.clearSelection();
        // set primary
        $widget = _w;
        this.addToSelection(_w, false);
      } else {
        this.clearSelection();
        $widget = undefined as any;
      }
    } else {
      e.stopPropagation();
      e.preventDefault();
      _w = this.getClosestWidget(e);

      // click on empty canvas area -> clear selection
      if (!_w || !_w.length) {
        this.clearSelection();
        $widget = undefined as any;
        // hide original focus node
        $focusNode?.attr('hidden', 'true');
        return;
      }

      // plain click (no shiftKey) => single-select (drop previous selection)
      if (!e.shiftKey) {
        // If clicked widget is already the only selected widget, early return
        const onlySelectedSame = $widget && _w && $widget[0] === _w[0] && this.selectionSet.size === 1;
        if (onlySelectedSame) {
          return;
        }
        this.clearSelection();
        $widget = _w;
        this.addToSelection(_w);
      } else if(this.isPrism) { // Handle multiselect autolayout only for prism projects
        if ($widget && $widget.length) {
          const $prevPrimary = $widget;
          const isSibling = this.areSiblings($widget, _w);
          if (!isSibling) {
            return;
          } else {
            const id = _w.attr('widget-id') || _w.attr('widgetid');
            const alreadySelected = id && this.selectionSet.has(id);

            if (alreadySelected) {
              if (this.selectionSet.size <= 1) {
                // keep the current selection. nothing to change.
                this.notificationService.show('info', '', 'At least one widget must remain selected')
                return;
              }

              // normal deselect when more than 1 is selected
              this.removeFromSelection(_w);

              if ($widget && $widget[0] === _w[0]) {
                if (this.$selectedWidgets && this.$selectedWidgets.length) {
                  $widget = this.$selectedWidgets.eq(0);
                } else {
                  $widget = undefined as any;
                }
              }
            } else {
              this.addToSelection(_w, false);

              if ($widget && $widget.length) {
                this.createMultiFocusNodeFor($widget);
              }

              $widget = _w;
            }
          }
        } else {
          $widget = _w;
          this.addToSelection(_w);
        }
      }
    }

    if (!$widget || !$widget[0]) {
      $focusNode?.attr('hidden', 'true');
      return;
    }

    $focusNode?.removeAttr('hidden');
    $focusNode?.css('display', 'inline-block');

    let name = get($widget[0], 'widget.name');

    // reset classes on focusNode and last selected widget
    $focusNode?.attr('class', 'wm-focus-rect');
    if(this._lastSelectedWidget) {
      this._lastSelectedWidget?.removeAttr('draggable');
    }

    if (this.isSelectedWidgetSortable()) {

    } else if ($widget.is('[movable-in-canvas]') && this.selectionSet.size === 1) {
      $widget?.addClass('movable');
      $widget?.attr('draggable', 'true');
      this._lastSelectedWidget = $widget;
    } else {
      if ($widget.is('.tab-pane, .app-wizard-step-content')) {
        $focusNode?.addClass('hide-toolbar');
      }
    }
    this.buildActionPanel($focusNode);
    setTimeout(() => {
      this.updateFocusNodePos();
    }, 500);
    this.setActiveObserver($widget);
  }

  setActiveObserver($widget: JQuery<HTMLElement>) {
    this.applyResizeObserver($widget);
  }

  getDropConfig() {
    if (!currentHighlightTarget || !currentHighlightSide) {
      return null;
    }

    const config: any = {};

    if (currentHighlightSide === 'inside') {
      config.parentId = currentHighlightTarget.closest('[widget-id]').attr('widget-id');
      // No referenceId/pos means append to end
    } else {
      const $parent = currentHighlightTarget.parent().closest('[widget-id]');
      config.parentId = $parent.attr('widget-id');
      config.referenceId = currentHighlightTarget.attr('widget-id');
      config.referencePos = (currentHighlightSide === 'left' || currentHighlightSide === 'top') ? 'before' : 'after';
    }

    return config;
  }

  getDefaultAddPos(config: any) {
    if (!$widget || !$widget.length) {
      // DEFAULT TO ROOT IF NO ACTIVE WIDGET
      const rootId = this.markupManager?.getMarkup()?.children().first().attr('widget-id') || '';
      config.parentId = rootId;
      return;
    }

    const $parent = $widget.parent().closest('[widget-id]');
    config.parentId = $parent.attr('widget-id');
    config.referenceId = $widget.attr('widget-id');
    config.referencePos = 'after';
  }

  buildActionPanel($focusNode: JQuery<HTMLElement> | undefined) {
    let widgetType = $widget.attr('widgetType');
    let widgetConfig = this.widgetProperties.getConfig(widgetType);
    let actionPanels = [
      'left',
      'right',
      'top',
      'bottom'
    ];
    actionPanels.forEach((name: string) => {
      let panel: any = $focusNode?.find('.'+ name + '-action-panel');
      let propName = name + 'ActionPanel';
      panel.empty();
      if (widgetConfig && widgetConfig[propName]) {
        //let myNwActions = await $(widgetConfig[propName]($widget[0].widget, $widget))
       $(widgetConfig[propName]($widget[0].widget, $widget).then((actions:any) => {
        if (!actions || actions.length === 0) {
          return;
        }
        actions.click((e:any) => {
          e.stopPropagation();
          setTimeout(() => {
            this.updateFocusNodePos();
          }, 300);
        });
        panel.append(actions);
        setTimeout(() => {
          if (name === 'left') {
            panel.css('margin-left', -1 * actions.offsetWidth);
            panel.css('margin-top', -1 * actions.offsetHeight / 2);
          } else if (name === 'right') {
            panel.css('margin-right', -1 * actions.offsetWidth);
            panel.css('margin-top', -1 * actions.offsetHeight / 2);
          } else {
            panel.css('margin-left', -1 * actions.offsetWidth / 2);
            panel.css('margin-bottom', -1 * actions.offsetHeight);
          }
        });
        }));
      }
    });
  }

  getCurrentPos($el: JQuery<HTMLElement>) {
    const config: any = {};
    const $parent = $el.parent().closest('[widget-id]');
    config.parentId = $parent.attr('widget-id');

    let $w = $el.prev();
    if ($w.length) {
      config.referenceId = $w.attr('widget-id');
      config.referencePos = 'after';
    } else {
      $w = $el.next();
      if ($w.length) {
        config.referenceId = $w.attr('widget-id');
        config.referencePos = 'before';
      }
    }

    return config;
  }

  isSelectedWidgetSortable() {
    return $widget.is('.app-grid-row, .app-grid-column, .app-nav > .app-nav-item, .app-button-group > .app-button');
  }

  notifyMovementForSort(config: { [key: string]: any }) {
    runtimeEventManager.emit('canvas-move-widget', config);
  }

  notifyAdd(config: DroppedWidgetInfo, browserEvent?: DropEvent) {
    // this.canvasDomComponent.addWidgetProxy(config);
    // $rs.$emit('wms:canvas-add-widget', config, browserEvent);
    browserEvent?.stopPropagation();
    this.eventManager.emitOnCanvasAdd(config);
    this.cleanupAddWidSuccess();
  }

  notifyMovement(event: DragOverEvent | DropEvent | Event) {
    let config: any = {};
    const newPos = this.getDropConfig();
    if (!newPos) {
      return;
    }
    const prevPos = this.getCurrentPos($widget);
    Object.assign(config, newPos);
    config.widgetId = $widget.attr('widget-id');
    config.prevParentId = prevPos.parentId;
    config.prevReferenceId = prevPos.referenceId;
    config.prevReferencePos = prevPos.referencePos;


    event.stopPropagation();
    this.ngZone.run(() => {
      this.eventManager.emitOnCanvasMove(config);
    });
    // $rs.$emit('wms:canvas-move-widget', config, browserEvent);
    this.cleanupMoveWidSuccess();
  }

  // METHOD TO CLEAR DROP HIGHLIGHTS
  private clearDropHighlight() {
    if (currentHighlightTarget) {
      currentHighlightTarget.removeClass('drop-highlight-inside');
      currentHighlightTarget = null;
      currentHighlightSide = null;
    }
    if (currentHighlightParent) {
      currentHighlightParent.removeClass('drop-highlight-container');
      currentHighlightParent = null;
    }

    this._hideDropVisuals();
    isHighlighted = false;
  }

  handleMoveWidgetDrag(e: DragOverEvent) {
    // ignore duplicate events w/o movement
    if (lastPos['pageX'] === e.pageX && lastPos['pageY'] === e.pageY) {
      return;
    }

    // if the widget being dragged and the target are same, ignore
    if ($widget && $widget[0] === e.target) {
      return;
    }

    // if pointer is inside the dragged widget's subtree, ignore
    if ($widget && $widget[0] && $widget[0].contains && $widget[0].contains(e.target as Node)) {
      return;
    }

    // update last pointer position (used by the dragover dedupe logic)
    lastPos['pageX'] = e.pageX;
    lastPos['pageY'] = e.pageY;

    // find the closest widget element under pointer
    const closestWidEl = (e.target as HTMLElement).closest('[widget-id]');
    if (!closestWidEl) {
      this.clearDropHighlight();
      return;
    }
    const $closestWid = $(closestWidEl) as JQuery<HTMLElement>;

    // find the closest droppable container up the tree
    const closestDroppableEl = closestWidEl.closest('[wm-droppable=true]');
    if (!closestDroppableEl) {
      this.clearDropHighlight();
      return;
    }
    const $droppableContainer = $(closestDroppableEl) as JQuery<HTMLElement>;

    // if it's a pagecontainer with content attribute, skip (preserves your old guard)
    const content = $closestWid.attr('content');
    if ($closestWid.is('[pagecontainer]') && content) {
      this.clearDropHighlight();
      return;
    }
    let $dropTarget = this.getDroppableTarget($closestWid, $droppableContainer);
    this._lastMouseClientX = e.clientX ?? (e.originalEvent && e.originalEvent.clientX) ?? null;
    this._lastMouseClientY = e.clientY ?? (e.originalEvent && e.originalEvent.clientY) ?? null;
    const $target = $(e.target).closest('[widgetid], [widget-id]');
    this._lastHoverTarget = $target;

    // call unified container-level highlight logic (robust client coord retrieval inside)
    this.updateDropHighlightInContainer($dropTarget, e);
  }

  handleAddWidgetDrag(e: any) {
    let evtData;

    if (!addWidgetInfo || !addWidgetInfo.widgetType) {
      return;
    }

    evtData = get(e, 'dataTransfer')?.getData('text') || get(e.originalEvent, 'dataTransfer')?.getData('text');

    // ignore repeated events with identical pointer unless it's the dnd simulation token
    if (evtData !== '__dnd__simulation__' && (lastPos['pageX'] === e.pageX && lastPos['pageY'] === e.pageY)) {
      return;
    }

    lastPos['pageX'] = e.pageX;
    lastPos['pageY'] = e.pageY;

    const closestWidEl = (e.target as HTMLElement).closest('[widget-id]');
    if (!closestWidEl) {
      this.clearDropHighlight();
      return;
    }
    const $closestWid = $(closestWidEl) as JQuery<HTMLElement>;

    const closestDroppableEl = closestWidEl.closest('[wm-droppable=true]');
    if (!closestDroppableEl) {
      this.clearDropHighlight();
      return;
    }
    const $droppableContainer = $(closestDroppableEl) as JQuery<HTMLElement>;

    const widContentAttr = $closestWid.attr('content');
    if ($closestWid.is('[pagecontainer]') && widContentAttr) {
      this.clearDropHighlight();
      return;
    }
    let $dropTarget = this.getDroppableTarget($closestWid, $droppableContainer);
    this._lastMouseClientX = e.clientX ?? (e.originalEvent && e.originalEvent.clientX) ?? null;
    this._lastMouseClientY = e.clientY ?? (e.originalEvent && e.originalEvent.clientY) ?? null;
    const $target = $(e.target).closest('[widgetid], [widget-id]');
    this._lastHoverTarget = $target;

    // unified container-based highlight
    this.updateDropHighlightInContainer($dropTarget, e);
  }

  getDroppableTarget($closestWid: JQuery<HTMLElement>, $closestDroppable: JQuery<HTMLElement>) {
    let $dropTarget = null;
    // if the closest widget is dropppable
    if ($closestWid?.attr('widget-id') === $closestDroppable?.attr('widget-id')) {
      // if the drop target is same as the root node of the widget, drop target will be the widget it self.
      // if not, find the drop target corresponding to the widget
      if ($closestWid?.attr('data-droptarget-for') === $closestWid?.attr('widget-id')) {
        $dropTarget = $closestWid;
      } else {
        $dropTarget = $closestWid?.find('[data-droptarget-for="' + $closestWid.attr('widget-id') + '"]');
      }

    } else {
      // current drop target is not droppable, need to place the widget before the drop target if the parent widget is droppable
      // is the parent widget of the current drop target droppable?
      let $parentWid = $closestWid?.parent().closest('[widget-id]');
      if ($parentWid?.attr('wm-droppable') === 'true') {
        if (
          $parentWid?.attr('data-droptarget-for') ===
          $parentWid?.attr('widget-id')
        ) {
          $dropTarget = $parentWid;
        } else {
          $dropTarget = $parentWid?.find(
            '[data-droptarget-for="' + $parentWid.attr('widget-id') + '"]'
          );
        }
      }
    }

    return $dropTarget;
  }

  handleMoveWidgetDrop(event: DragOverEvent | DropEvent | Event) {
    if (action !== ACTIONS.MOVE || !isHighlighted) {
      return;
    }

    moveSuccess = true;

    //update the markup changes
    this.notifyMovement(event);
  }

  getAddWidgetConfig() {
    return addWidgetInfo;
  }

  setAddWidgetConfig(widgetConfig: any): void {
    addWidgetInfo = widgetConfig;
  }

  handleAddWidgetDrop(browserEvent: DropEvent) {
    if (action !== ACTIONS.ADD || !isHighlighted) {
      return;
    }
    let config: any, widgetInfo;
    config = this.getAddWidgetConfig();

    const {widgetType} = config;

    const dropConfig = this.getDropConfig();
    if (!dropConfig) {
      return;
    }
    Object.assign(config, dropConfig);

    if (config.widgetType === 'wm-prefab') {
      config.prefabName = getValidJSON(config.widgetDefaults).prefabName;
    }
    else if (config.widgetType === 'wm-custom-widget') {
      config.widgetName = getValidJSON(config.widgetDefaults).widgetName;
    }
    else if (config.widgetType === 'wmx-component') {
      config.componentName =  getValidJSON(config.widgetDefaults).componentName;
    }

    widgetInfo = config.widgetType && this.widgetProperties.getConfig(config.widgetType);
    
    if (this.projectService.isAutolayoutAllowed()) {
      if (widgetInfo.widgetType === "wm-form") {
        widgetInfo.config.screens[0].templates = [
          {
            "id": "one-column",
            "title": "1 column",
            "labelKey": "LABEL_1_COLUMN",
            "platform": ["WEB", "MOBILE", "NATIVE_MOBILE"],
            "template": '<wm-form errormessage="" captionposition="top" title="Form" enctype="application/x-www-form-urlencoded" itemsperrow="xs-1 sm-1 md-1 lg-1">' +
              '<wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container>' +
              '<wm-form-action key="reset" class="form-reset btn-default" iconclass="wi wi-refresh" display-name="Reset" type="reset"></wm-form-action>' +
              '<wm-form-action key="save" class="form-save btn-success" iconclass="wi wi-save" display-name="Save" type="submit"></wm-form-action>' +
              '</wm-form>'
          },
          {
            "id": "two-column",
            "title": "2 column",
            "labelKey": "LABEL_2_COLUMN",
            "platform": ["WEB"],
            "template": '<wm-form errormessage="" captionposition="top" title="Form" enctype="application/x-www-form-urlencoded" itemsperrow="xs-2 sm-2 md-2 lg-2">' +
              '<wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container>' +
              '<wm-form-action key="reset" class="form-reset btn-default" iconclass="wi wi-refresh" display-name="Reset" type="reset"></wm-form-action>' +
              '<wm-form-action key="save" class="form-save btn-success" iconclass="wi wi-save" display-name="Save" type="submit"></wm-form-action>' +
              '</wm-form>'
          },
          {
            "id": "three-column",
            "title": "3 column",
            "labelKey": "LABEL_3_COLUMN",
            "platform": ["WEB"],
            "template": '<wm-form errormessage="" captionposition="top" title="Form" enctype="application/x-www-form-urlencoded" itemsperrow="xs-3 sm-3 md-3 lg-3">' +
              '<wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container>' +
              '<wm-form-action key="reset" class="form-reset btn-default" iconclass="wi wi-refresh" display-name="Reset" type="reset"></wm-form-action>' +
              '<wm-form-action key="save" class="form-save btn-success" iconclass="wi wi-save" display-name="Save" type="submit"></wm-form-action>' +
              '</wm-form>'
          },
          {
            "id": "dialog-form",
            "title": "Dialog Form",
            "labelKey": "LABEL_MOBILE_DIALOG_FORM",
            "platform": ["MOBILE"],
            "requireColumns": false,
            "template": "<wm-form  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='dialog'><wm-container></wm-container></wm-form>"
          }
        ]
      }else if(widgetInfo.widgetType === "wm-card") {
        widgetInfo.config.screens[0].templates =        [
            {
              "id": "blank-card",
              "title": "Blank",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Blank Card" itemsperrow="auto" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                `<wm-container direction="row" alignment="top-left" gap="4" width="280px"
                    class="app-container-default" variant="default" height="260px" name="Blank"
                    padding="12px"></wm-container>` +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-card",
              "title": "Text",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Text Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="24px">' +
                '<wm-linearlayout direction="column" horizontalalign="left" verticalalign="center">' +
                '<wm-linearlayoutitem>' +
                '<wm-linearlayout direction="row" spacing="15" verticalalign="center">' +
                '<wm-linearlayoutitem flexgrow="1">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem width="25px">' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px"></wm-icon>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-card",
              "title": "Text",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Text Card" itemsperrow="auto" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                `<wm-container direction="column" alignment="middle-center" gap="8" width="280" name="Card" wrap="false"
                    padding="12px" class="app-container-default" variant="default">
                    <wm-container direction="column" alignment="top-left" gap="4" width="fill" name="text" wrap="false"
                        class="app-container-default" variant="default">
                        <wm-label padding="unset" caption="{}" data-is-target class="h5 p" type="p" variant="default:p" show="true"
                            required="required" name="Title"></wm-label>
                        <wm-label padding="unset"
                            caption="{}" data-is-target
                            class="p" type="p" variant="default:p" show="true" required="required" name="Body">
                        </wm-label>
                    </wm-container>
                </wm-container>` +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-action-card",
              "title": "Text With Action",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": ' <wm-list listclass="list-group" template="true" template-name="Text with Action Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="24px">' +
                '<wm-linearlayout direction="column" horizontalalign="left" verticalalign="center">' +
                '<wm-linearlayoutitem>' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" margin="0px" class="h5" fontweight="bold"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-card-content>' +
                '<wm-card-footer padding="16px 24px" horizontalalign="right">' +
                '<wm-linearlayout direction="column">' +
                '<wm-linearlayoutitem>' +
                '<wm-button type="button" class="btn-primary" textalign="center" caption="Action" padding="8px 24px"></wm-button>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-action-card",
              "title": "Text With Action",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Text with Action Card" itemsperrow="auto" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                `<wm-container direction="column" alignment="middle-center" gap="8" width="280" name="Card" wrap="false"
                    padding="12px" class="app-container-default" variant="default">
                    <wm-container direction="column" alignment="top-left" gap="4" width="fill" name="Text" wrap="false"
                        class="app-container-default" variant="default">
                        <wm-label padding="unset" caption="{}" data-is-target class="h5 p" type="p" variant="default:p" show="true"
                            required="required" name="Title"></wm-label>
                        <wm-label padding="unset"
                            caption="{}" data-is-target
                            class="p" type="p" variant="default:p" show="true" required="required" name="Body">
                        </wm-label>
                    </wm-container>
                    <wm-container direction="row" alignment="middle-right" gap="4" width="fill"
                        class="app-container-default" variant="default" height="hug" name="Button">
                        <wm-button class="btn-filled btn-default" caption="Button" type="button" margin="unset"
                            name="button2" variant="filled:default"></wm-button>
                        <wm-button class="btn-filled btn-primary" caption="Button" type="button" margin="unset"
                            variant="filled:primary" name="button4"></wm-button>
                    </wm-container>
                </wm-container>` +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-card",
              "title": "Media",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="0px">' +
                '<wm-linearlayout direction="column" horizontalalign="left" verticalalign="center">' +
                '<wm-linearlayoutitem>' +
                '<wm-picture name="Picture" picturesource="{}" data-is-target shape="rounded" resizemode="cover" class="img-responsive" width="100%"></wm-picture>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '<wm-linearlayout direction="column" horizontalalign="left" verticalalign="center" padding="24px">' +
                '<wm-linearlayoutitem>' +
                '<wm-linearlayout direction="row" spacing="12" verticalalign="center">' +
                '<wm-linearlayoutitem flexgrow="1">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem width="25px">' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px" iconposition="left"></wm-icon>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-card",
              "title": "Media",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Card" itemsperrow="auto" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                `<wm-container direction="column" alignment="middle-center" gap="8" width="280" name="Card" wrap="false"
                    padding="12px" class="app-container-default" variant="default">
                    <wm-picture resizemode="cover" class="img-rounded" variant="default:rounded" width="100%"
                        picturesource="{}" data-is-target name="Picture">
                    </wm-picture>
                    <wm-container direction="column" alignment="top-left" gap="4" width="fill" name="Text" wrap="false"
                        class="app-container-default" variant="default">
                        <wm-label padding="unset" caption="{}" data-is-target class="h5 p" type="p" variant="default:p" show="true"
                            required="required" name="Title"></wm-label>
                        <wm-label padding="unset"
                            caption="{}" data-is-target
                            class="p" type="p" variant="default:p" show="true" required="required" name="Body">
                        </wm-label>
                    </wm-container>
                </wm-container>` +  
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-with-action-card",
              "title": "Media with Action",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media with Action Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL" navigation="Basic">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content padding="0px">' +
                '<wm-linearlayout direction="column" horizontalalign="left" verticalalign="center">' +
                '<wm-linearlayoutitem>' +
                '<wm-picture name="Picture" picturesource="{}" data-is-target shape="rounded" resizemode="cover" class="img-responsive" width="100%"></wm-picture>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '<wm-linearlayout direction="column" horizontalalign="left" verticalalign="center" padding="24px">' +
                '<wm-linearlayoutitem>' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="18px unset unset unset">' +
                '<wm-label name="Description_Heading" caption="Description:" class="h5" margin="0px" fontweight="bold"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem padding="4px unset unset unset">' +
                '<wm-label name="Description" caption="{}" data-is-target class="h5" margin="0px"></wm-label>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-card-content>' +
                '<wm-card-footer name="card_footer1" padding="16px 24px" horizontalalign="right">' +
                '<wm-linearlayout direction="row" spacing="10">' +
                '<wm-linearlayoutitem>' +
                '<wm-button type="button" class="btn-primary" textalign="center" caption="Action1" padding="8px 24px"></wm-button>' +
                '</wm-linearlayoutitem>' +
                '<wm-linearlayoutitem>' +
                '<wm-button type="button" class="btn-secondary" textalign="center" caption="Action2" padding="8px 24px"></wm-button>' +
                '</wm-linearlayoutitem>' +
                '</wm-linearlayout>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-with-action-card",
              "title": "Media with Action",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Card" itemsperrow="auto" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                `<wm-container direction="column" alignment="middle-center" gap="8" width="280" wrap="false"
                    padding="12px" class="app-container-default" variant="default"
                    name="container8">
                    <wm-picture resizemode="cover" class="img-rounded" variant="default:rounded" width="100%"
                        picturesource="{}" data-is-target name="Picture">
                    </wm-picture>
                    <wm-container direction="column" alignment="top-left" gap="4" width="fill" wrap="false"
                        class="app-container-default" variant="default" name="container9">
                        <wm-label padding="unset" caption="{}" data-is-target class="h5 p" type="p" variant="default:p" show="true"
                            required="required" name="Title"></wm-label>
                        <wm-label padding="unset"
                            caption="{}" data-is-target
                            class="p" type="p" variant="default:p" show="true" required="required" name="Body">
                        </wm-label>
                    </wm-container>
                    <wm-container direction="row" alignment="middle-right" gap="4" width="fill"
                        class="app-container-default" variant="default" height="hug" name="container10">
                        <wm-button class="btn-filled btn-default" caption="Button" type="button" margin="unset"
                            variant="filled:default" name="button5"></wm-button>
                        <wm-button class="btn-filled btn-primary" caption="Button" type="button" margin="unset"
                            variant="filled:primary" name="button6"></wm-button>
                    </wm-container>
                </wm-container>` +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "bussiness-card",
              "title": "Business Card",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Business Card" itemsperrow="xs-1 sm-2 md-3 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card>' +
                '<wm-card-content fontsize="0.8" fontunit="em">' +
                '<wm-container direction="row" alignment="top-left" width="fill" padding="8">' +
                '<wm-container direction="row" alignment="top-left" padding="8" width="50%" height="fill">' +
                '<wm-picture name="Picture" width="100%" data-is-target picturesource="{}" aspect-ratio="4:3 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container direction="column" alignment="top-left" width="50%" padding="8px 1.25em" height="fill">' +
                '<wm-label name="ID" data-is-target caption="{}" class="text-muted p" margin="unset unset 0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Name" data-is-target caption="{}" class="h4" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" class="h5" margin="0px unset unset unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Department" data-is-target caption="{}" class="p text-muted" name="label7" margin="unset unset 0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Location" data-is-target caption="{}" class="text-muted p" whitespace="nowrap"></wm-label>' +
                '<wm-anchor name="PhoneNumber" data-is-target caption="{}" class="h5" hyperlink="tel:" margin="0px unset" whitespace="nowrap"></wm-anchor>' +
                '<wm-anchor name="EmailID" class="p text-muted" hyperlink="mailto://" data-is-target caption="{}" whitespace="nowrap"></wm-anchor>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "contact-card",
              "title": "Contact Card",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-2 sm-4 md-6 lg-6" template="true" template-name="Contact Card" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="ContactCard">' +
                '<wm-card-content horizontalalign="center">' +
                '<wm-container direction="row" alignment="top-center" width="fill" padding="16">' +
                '<wm-picture name="Picture" shape="circle" data-is-target picturesource="{}" width="60%"></wm-picture>' +
                '</wm-container>' +
                '<wm-label name="Name" class="h4 text-center" margin="unset unset 0em unset"  data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" class="p text-muted  text-center" data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "designation-card",
              "title": "Designation Card",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-2 sm-3 md-4 lg-6" template="true" template-name="Designation Card" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="4:3 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" class="h4" margin="0px unset" data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '<wm-label name="JobTitle" class="p text-muted"  data-is-target caption="{}" whitespace="nowrap"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "i-card",
              "title": "I Card",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="I Card" itemsperrow="xs-1 sm-2 md-4 lg-6" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label data-is-target caption="{}" name="Name" margin="0px unset unset unset"  class="h4" whitespace="nowrap"></wm-label>' +
                '<wm-container direction="column" alignment="top-left" padding="8" gap="4" width="fill" columns="2">' +
                '<wm-container direction="row" alignment="middle-left" width="fill" gap="17.5" padding="8px">' +
                '<wm-icon iconclass="wi wi-contact-mail fa-2x" class="text-muted"></wm-icon>' +
                '<wm-label name="ID" data-is-target caption="{}" fontunit="em" class="text-muted p" whitespace="nowrap"></wm-label>' +
                '</wm-container>' +
                '<wm-container direction="row" alignment="middle-left" width="fill" gap="17.5" padding="8px">' +
                '<wm-icon iconclass="wi wi-user fa-2x" class="text-muted"></wm-icon>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" fontunit="em" class="text-muted p"></wm-label>' +
                '</wm-container>' +
                '<wm-container direction="row" alignment="middle-left" width="fill" gap="17.5" padding="8px">' +
                '<wm-icon iconclass="wi wi-dashboard fa-2x" class="text-muted"></wm-icon>' +
                '<wm-label name="Department" data-is-target caption="{}" fontunit="em" class="text-muted"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-buttongroup class="btn-group-justified" horizontalalign="center">' +
                '<wm-anchor class="btn btn-transparent text-muted" caption="" iconclass="wi wi-mail fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-call fa-2x"></wm-anchor>' +
                '<wm-anchor class="btn btn-transparent" caption="" iconclass="wi wi-location-on fa-2x"></wm-anchor>' +
                '</wm-buttongroup>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-overview",
              "title": "Product Overview",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Overview" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" title="{}" subheading="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content padding="1.5em unset unset unset">' +
                '<wm-button class="btn-fab btn-warning pull-right btn-lg" caption="" type="button" name="button2" iconclass="wi wi-cart" margin="-3.5em 0.5em unset unset"></wm-button>' +
                '<wm-container direction="row" alignment="top-left" width="fill" padding="8">' +
                '<wm-container direction="row" alignment="top-left" width="fill" padding="8" height="fill">' +
                '<wm-label name="Price"  data-is-target caption="{}" fontsize="1.286" fontunit="em"></wm-label>' +
                '</wm-container>' +
                '<wm-container direction="column" alignment="top-right" width="fill" padding="8" height="fill">' +
                '<wm-label name="Quantity" data-is-target fontsize="1.286" fontunit="em" caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '<wm-label name="Description" data-is-target class="p text-muted" caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="VIEW ALL SPECIFICATIONS" class="btn btn-transparent"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-thumbnail",
              "title": "Product Thumbnail",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Thumbnail" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Thumbnail" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" data-is-target caption="{}" fontsize="1.286" fontunit="em" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="Model" data-is-target caption="{}" class="text-muted"></wm-label>' +
                '<wm-container direction="row" alignment="top-left" width="fill" padding="8">' +
                '<wm-container direction="column" alignment="top-left" width="fill" height="fill" padding="8" gap="6" class="col-xs-6">' +
                '<wm-label name="Currency" data-is-target caption="{}" color="#ba5d1e"></wm-label>' +
                '<wm-label name="Price" data-is-target caption="{}" fontsize="1.571" fontunit="em" color="#ba5d1e" margin="unset unset 1px unset"></wm-label>' +
                '</wm-container>' +
                '<wm-container direction="column" alignment="top-right" width="fill" height="fill" padding="8" gap="6" class="col-xs-6">' +
                '<wm-label name="Quantity" fontsize="1.286" fontunit="em" data-is-target caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="ADD TO CART" class="btn btn-transparent text-warning"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "product-inventory",
              "title": "Product Inventory",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Product Inventory" itemsperrow="xs-1 sm-2 md-4 lg-4" class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content>' +
                '<wm-label name="Name" class="h4" data-is-target caption="{}" margin="unset unset 0px unset"></wm-label>' +
                '<wm-label name="Model" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '<wm-label name="Quantity" data-is-target fontsize="1.286" fontunit="em" caption="{}" margin="unset 0.2em unset unset"></wm-label>' +
                '<wm-label name="HelpText" caption="Available"></wm-label>' +
                '<wm-label name="Description" data-is-target class="p text-muted" caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-anchor caption="VIEW ALL SPECIFICATIONS" class="btn btn-transparent"></wm-anchor>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "media-post",
              "title": "Media Post",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="Media Post" itemsperrow="xs-1 sm-2 md-2 lg-3" class="media list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container direction="column" alignment="top-left" width="fill">' +
                '<wm-container direction="row" alignment="top-left" width="fill" >' +
                '<wm-container direction="row" alignment="top-left" padding="unset 10px unset 6.5px">' +
                '<wm-picture shape="circle" name="Avatar" data-is-target width="32pt" height="32pt" picturesource="{}" aspect-ratio="16:9 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" direction="column" width="fill" height="fill" alignment="top-left">' +
                '<wm-label class="h4" caption="{}" data-is-target name="Name" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Date" data-is-target caption="{}" class="p text-muted" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '<wm-card name="Picture" data-is-target picturesource="{}">' +
                '<wm-card-content name="card_content1" padding="1.25em">' +
                '<wm-label caption="{}" data-is-target name="Title" margin="0px unset unset unset" fontunit="em" class="h4"></wm-label>' +
                '<wm-label name="Description" data-is-target class="p text-muted" whitespace="nowrap" caption="{}" margin="unset unset 1em unset"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-container direction="row" alignment="top-left" width="fill" padding="8">' +
                '<wm-container direction="row" alignment="top-left" width="33.33%" height="fill" padding="8">' +
                '<wm-anchor class="text-warning" caption="READ MORE"></wm-anchor>' +
                '</wm-container>' +
                '<wm-container direction="row" alignment="top-right" width="66.67%" height="fill" padding="8">' +
                '<wm-anchor iconclass="wi wi-share fa-2x" class="btn btn-transparent" caption="75" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-comments fa-2x" caption="50" class="btn btn-transparent"></wm-anchor>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "news-post",
              "title": "News Post",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" template="true" template-name="News Post" itemsperrow="xs-1 sm-2 md-2 lg-3" class="media list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container direction="column" alignment="top-left" width="fill">' +
                '<wm-container direction="row" alignment="top-left" width="fill" >' +
                '<wm-container direction="row" alignment="top-left" padding="unset 10px unset 6.5px">' +
                '<wm-picture shape="circle" data-is-target name="Avatar" width="32pt" height="32pt" picturesource="{}" aspect-ratio="16:9 or 1:1"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" direction="column" width="fill" height="fill" alignment="top-left">' +
                '<wm-label class="h4" data-is-target caption="{}" name="Name" margin="0px unset" whitespace="nowrap"></wm-label>' +
                '<wm-label name="Date" data-is-target caption="{}" class="p text-muted" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '</wm-container>' +
                '</wm-container>' +
                '<wm-card>' +
                '<wm-card-content padding="2em">' +
                '<wm-label caption="{}" data-is-target name="Title" margin="0px unset unset unset" fontunit="em" class="h4"></wm-label>' +
                '<wm-label name="Description" class="p" data-is-target caption="{}"></wm-label>' +
                '</wm-card-content>' +
                '<wm-card-footer>' +
                '<wm-container direction="row" alignment="top-left" padding="8">' +
                '<wm-container direction="row" alignment="top-left" width="33.33%" padding="8" height="fill" >' +
                '<wm-anchor caption="READ MORE"></wm-anchor>' +
                '</wm-container>' +
                '<wm-container direction="row" alignment="top-right" width="66.67%" padding="8" height="fill">' +
                '<wm-anchor iconclass="wi wi-share fa-2x" class="btn btn-transparent" caption="425" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-thumb-up fa-2x" class="btn btn-transparent" caption="75" margin="unset 1em unset unset"></wm-anchor>' +
                '<wm-anchor iconclass="wi wi-comments fa-2x" caption="50" class="btn btn-transparent"></wm-anchor>' +
                '</wm-container>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "personal-spotlight",
              "title": "Personal Spotlight",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemsperrow="xs-1 sm-2 md-3 lg-4" template="true" template-name="Personal Spotlight"  class="list-card" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-card name="Picture" data-is-target picturesource="{}" aspect-ratio="16:9 or 1:1">' +
                '<wm-card-content padding="1.25em">' +
                '<wm-label name="Name" class="h4 text-muted" width="100%" data-is-target caption="{}" whitespace="nowrap" margin="0px unset unset unset"></wm-label>' +
                '<wm-label name="Title" data-is-target caption="{}" class="h4" margin="0px unset unset unset"></wm-label>' +
                '<wm-label name="Description" data-is-target caption="{}" class="p text-muted" margin="0px unset unset unset"></wm-label>' +
                '<wm-container direction="row" alignment="start" width="fill" gap="auto" padding="16" >' +
                '<wm-label name="Date" data-is-target caption="{}" class="text-muted" margin="0.6em unset unset unset" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-anchor class="btn btn-transparent" iconclass="wi wi-comments fa-2x" caption="50"></wm-anchor>' +
                '</wm-container>' +
                '</wm-card-content>' +
                '<wm-card-footer horizontalalign="center">' +
                '<wm-container direction="row" alignment="top-left" padding="8">' +
                '<wm-anchor caption="75" iconclass="wi wi-share fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '<wm-anchor caption="425" iconclass="wi wi-share fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '<wm-anchor caption="60" iconclass="wi wi-remove-red-eye fa-2x" class="btn btn-transparent"></wm-anchor>' +
                '</wm-container>' +
                '</wm-card-footer>' +
                '</wm-card>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            }
          ]
      }else if(widgetInfo.widgetType === "wm-liveform"){
        widgetInfo.config.screens[0].templates = [
            {
              "id": "one-column",
              "title": "1 column",
              "labelKey": "LABEL_1_COLUMN",
              "platform": ["WEB"],
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' itemsperrow='xs-1 sm-1 md-1 lg-1'><wm-container direction='row' alignment='top-left' wrap='true' width='fill'></wm-container></wm-liveform>"
            },
            {
              "id": "two-column",
              "title": "2 column",
              "labelKey": "LABEL_2_COLUMN",
              "platform": ["WEB"],
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' itemsperrow='xs-2 sm-2 md-2 lg-2'><wm-container direction='row' alignment='top-left' wrap='true' width='fill'></wm-container></wm-liveform>"
            },
            {
              "id": "three-column",
              "title": "3 column",
              "labelKey": "LABEL_3_COLUMN",
              "platform": ["WEB"],
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' itemsperrow='xs-3 sm-3 md-3 lg-3'><wm-container direction='row' alignment='top-left' wrap='true' width='fill'></wm-container></wm-liveform>"
            },
            {
              "id": "mobile-inline",
              "title": "Inline",
              "labelKey": "LABEL_MOBILE_INLINE",
              "platform": ['MOBILE', 'NATIVE_MOBILE'],
              "requireColumns": false,
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='inline'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "mobile-page",
              "title": "Page",
              "labelKey": "LABEL_MOBILE_PAGE",
              "platform": ["MOBILE"],
              "requireColumns": false,
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='page'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            },
            {
              "id": "dialog-form",
              "title": "Dialog Form",
              "labelKey": "LABEL_MOBILE_DIALOG_FORM",
              "platform": ["MOBILE"],
              "requireColumns": false,
              "template": "<wm-liveform  errormessage='' title='Details' iconclass='wi wi-edit' formlayout='dialog'><wm-layoutgrid></wm-layoutgrid></wm-liveform>"
            }
          ]
      }else if (widgetInfo.widgetType === "wm-tile") {
        widgetInfo.template = "<wm-tile class='bg-primary'>" +
          "<wm-container height='100%' direction='row' width='fill' alignment='top-left' padding='8'>" +
          "<wm-container direction='row' alignment='top-center' padding='8px' width='25%' height='fill'>" +
          "<wm-icon name='tileIcon' iconclass='wi wi-bar-chart fa-3x'></wm-icon>" +
          "</wm-container>" +
          "<wm-container direction='column' alignment='top-center' padding='8px' width='75%' height='fill'>" +
          "<wm-label name='tileTitle' caption='title' class='p' fontunit='em'></wm-label>" +
          "<wm-label name='tileStatLabel' caption='00' fontunit='em' class='h1'></wm-label>" +
          "</wm-container>" +
          "</wm-gridrow>" +
          "</wm-tile>"
      }else if (widgetInfo.widgetType === "wm-design-dialog") {
        widgetInfo.template = '<wm-dialog dialogtype="design-dialog" modal="true" title="Information" iconclass="wi wi-file-text">' +
      '<wm-container  direction="row" alignment="top-left" width="fill" gap="16" wrap="true" columngap="250">' +
      '<wm-label padding="unset 0.5em" caption="Name"></wm-label>' +
      '<wm-label padding="unset 0.5em" caption="Eric"></wm-label>' +
      '<wm-label padding="unset 0.5em" caption="Title"></wm-label>' +
      '<wm-label padding="unset 0.5em" caption="Engineer"></wm-label>' +
      '</wm-container>' +
      '<wm-dialogactions>' +
      '<wm-button class="btn-primary" caption="Close" on-click="closeDialog()"></wm-button>' +
      '</wm-dialogactions>' +
      '</wm-dialog>'
      }else if(widgetInfo.widgetType === "wm-table"){
        widgetInfo.config.screens[0].templates =  [
            {
              "id": "readonly-grid",
              "title": "Simple View only",
              "labelKey": "LABEL_SIMPLE_VIEW_ONLY",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-table statehandler="URL">' +
                '</wm-table>'
            },
            {
              "id": "editable-grid",
              "title": "Inline Editable",
              "labelKey": "LABEL_INLINE_EDITABLE",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table editmode="inline" statehandler="URL">' +
                '</wm-table>'
            },
            {
              "id": "grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-livetable formlayout="dialog">' +
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "crud-grid-form-dialog",
              "title": "Form as Dialog",
              "labelKey": "LABEL_FORM_AS_DIALOG",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table gridfirstrowselect="true" editmode="dialog" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container></wm-form>'
            },
            {
              "id": "crud-grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container></wm-form>'
            },
            {
              "id": "crud-grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-form  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container></wm-form>'
            },
            {
              "id": "grid-form",
              "title": "Form Below",
              "labelKey": "LABEL_FORM_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" editmode="form" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage=""  title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "grid-form-readonly",
              "title": "Details Below",
              "labelKey": "LABEL_DETAILS_BELOW",
              "platform": ["WEB", "MOBILE"],
              "isEditable": false,
              "template":
                '<wm-livetable>' +
                '<wm-table gridfirstrowselect="true" statehandler="URL"></wm-table>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="inline" iconclass="wi wi-edit"><wm-container direction="row" alignment="top-left" wrap="true" width="fill"></wm-container></wm-liveform>' +
                '</wm-livetable>'
            },
            {
              "id": "quick-inline-editable",
              "title": "Quick Edit",
              "labelKey": "LABEL_QUICK_EDIT",
              "platform": ["WEB", "MOBILE"],
              "isEditable": true,
              "template":
                '<wm-table editmode="quickedit" statehandler="URL">' +
                '</wm-table>'
            }
          ]
      }else if(widgetInfo.widgetType === "wm-list") {
        widgetInfo.config.screens[0].templates = [
            {
              "id": "blank-list",
              "title": "Blank",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Blank List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                `<wm-container direction="row" alignment="top-left" gap="4" width="fill" name="List"
                    class="app-elevated-container" variant="elevated" padding="12px" height="56"></wm-container>` +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-list",
              "title": "Text",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-label name="Text" caption="{}" data-is-target class="h4" padding="12px"></wm-label>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-list",
              "title": "Text",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                `<wm-container direction="column" alignment="top-left" gap="0" width="fill" wrap="false"
                    class="app-elevated-container" variant="elevated" name="list_text" height="hug" padding="12px">
                    <wm-label padding="unset" caption="{}" data-is-target class="h5" type="p" variant="default:h5" show="true"
                        required="required" name="Title"></wm-label>
                    <wm-label padding="unset"
                        caption="{}" data-is-target
                        class="p" type="p" variant="default:p" show="true" required="required" name="Body"></wm-label>
                </wm-container>` +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-avatar-list",
              "title": "Text with Avatar",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Avatar List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container direction="row" alignment="middle-left" gap="12" width="fill" name="container4" class="app-default-container" variant="default" padding="12px">' +      
                '<wm-picture width="58px" height="58px" name="Picture" picturesource="{}" data-is-target shape="circle" resizemode="cover" class="media-object"></wm-picture>' +
                '<wm-container direction="column" flexgrow="1" gap="12" width="fill">' +
                '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold"></wm-label>' +
                '<wm-label name="SubTitle" caption="{}" data-is-target class="h5"></wm-label>' +
                '</wm-container>' +
                '<wm-icon iconclass="wi wi-more-vert" iconsize="22px"></wm-icon>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-avatar-list",
              "title": "Text with Avatar",
              "category": "Basic",
              "platform": ["WEB"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Avatar List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                `<wm-container direction="row" alignment="top-left" gap="4" width="fill" name="List"
                    class="app-elevated-container" variant="elevated" padding="12px">
                    <wm-picture resizemode="cover" class="img-circle img-rounded" variant="default:rounded" width="24px"
                        height="24px" picturesource="{}" data-is-target name="Picture">
                    </wm-picture>
                    <wm-container direction="column" alignment="top-left" gap="0" width="fill" wrap="false"
                        class="app-container-default" variant="default" name="text" height="hug">
                        <wm-label padding="unset" caption="{}" data-is-target class="h5" type="p" variant="default:h5" show="true"
                            required="required" name="Title"></wm-label>
                        <wm-label padding="unset"
                            caption="{}" data-is-target
                            class="p" type="p" variant="default:p" show="true" required="required" name="Body">
                        </wm-label>
                    </wm-container>
                    <wm-container direction="row" alignment="middle-center" gap="4" width="32" name="icon"
                        class="app-container-default" variant="default" height="32">
                        <wm-icon class="fa-sm" variant="default:sm" iconclass="wm-sl-r sl-more-vertical" name="icon1"
                            iconposition="right"></wm-icon>
                    </wm-container>
                </wm-container>` +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "text-with-description-list",
              "title": "Text with Description",
              "category": "Basic",
              "platform": ["NATIVE_MOBILE"],
               "template":
                      ' <wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Description List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                      '<wm-listtemplate layout="inline">' +
                      ' <wm-container direction="row" alignment="top-left" gap="12" name="container4" class="app-default-container" variant="default" padding="12px">' +
                      '<wm-picture width="58px" height="58px" name="Picture" picturesource="{}" data-is-target shape="circle" resizemode="cover" class="media-object"></wm-picture>' +
                      '<wm-container direction="column" spacing="4">' +
                      '<wm-label name="Title" caption="{}" data-is-target class="h4" fontweight="bold"></wm-label>' +
                      '<wm-label name="SubTitle" caption="{}" margin="unset 4px" data-is-target></wm-label>' +
                      '<wm-label name="Description" caption="{}" data-is-target class="h5"></wm-label>' +
                      "</wm-container" +
                      "</wm-container>" +
                      "</wm-listtemplate>" +
                      "</wm-list>",
            },
            {
              "id": "text-with-description-list",
              "title": "Text with Description",
              "category": "Basic",
              "platform": ["WEB"],
               "template":
                      ' <wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Text with Description List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                      '<wm-listtemplate layout="inline">' +
                      `<wm-container direction="row" alignment="top-left" gap="4" width="fill" name="List"
                          class="app-elevated-container" variant="elevated" padding="12px">
                          <wm-picture resizemode="cover" class="img-circle img-rounded" variant="default:rounded" width="24px"
                              height="24px" picturesource="{}" data-is-target name="Picture">
                          </wm-picture>
                          <wm-container direction="column" alignment="top-left" gap="0" width="fill" wrap="false"
                              class="app-container-default" variant="default" name="text" height="hug">
                              <wm-label padding="unset" caption="{}" data-is-target class="h5" type="p" variant="default:h5" show="true"
                                  required="required" name="Title"></wm-label>
                              <wm-label padding="unset"
                                  caption="{}" data-is-target
                                  class="p" type="p" variant="default:p" show="true" required="required" name="Body">
                              </wm-label>
                          </wm-container>
                      </wm-container>` +
                      "</wm-listtemplate>" +
                      "</wm-list>",
            },
            {
              "id": "action-list",
              "title": "Action List",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Action List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
                '<wm-label name="Name" data-is-target class="p media-heading" caption="{}" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-label name="JobTitle" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right media-top">' +
                '<wm-button type="button" class="btn-transparent" iconclass="wi wi-share fa-2x"></wm-button>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "contact-list",
              "title": "Contact List",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Contact List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" datafield="All Fields" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label class="p media-heading" name="Name" data-is-target caption="{}" fontunit="em" padding="unset unset unset 1.25em"></wm-label>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'
            },
            {
              "id": "email-list",
              "title": "Email List",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Email List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="inline">' +
                '<wm-container name="pictureContainer" class="media-left">' +
                '<wm-picture width="32pt" height="32pt" name="Picture" shape="circle" data-is-target picturesource="{}" class="media-object"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset unset unset 1.25em">' +
                '<wm-label name="Name" data-is-target class="media-heading pull-left" caption="{}" fontunit="em"></wm-label>' +
                '<wm-label name="Time" data-is-target caption="{}" class="pull-right" margin="0px unset unset unset"></wm-label>' +
                '<wm-label caption="{}" data-is-target class="h5" margin="0px unset unset unset" name="JobTitle"></wm-label>' +
                '<wm-label name="Content" data-is-target caption="{}" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right"></wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'

            },
            {
              "id": "media-list",
              "title": "Media List",
              "platform": ["MOBILE"],
              "template": '<wm-list listclass="list-group" itemclass="list-group-item" template="true" template-name="Media List" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container class="media-left media-top">' +
                '<wm-picture name="Picture" data-is-target class="media-object" width="32pt" height="32pt" picturesource="{}"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body" padding="unset 1.5em unset 1.25em">' +
                '<wm-label class="pull-left" caption="{}" data-is-target name="Name" margin="0em unset 0.5em unset" fontsize="1.143" fontunit="em"></wm-label>' +
                '<wm-label name="Time" data-is-target class="pull-right text-muted" caption="{}"></wm-label>' +
                '<wm-label caption="{}" data-is-target name="Description" class="p text-muted"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right" horizontalalign="right" padding="unset 1em unset unset">' +
                '<wm-menu autoclose="outsideClick" caption="" type="anchor" iconclass="wi wi-more-vert" menuposition="down,left"></wm-menu>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>'

            },
            {
              "id": "list-form-device",
              "title": "List with Form",
              "platform": ["MOBILE"],
              "template":
                '<wm-list listclass="list-group" itemclass="list-group-item media" template="true" itemsperrow="xs-1 sm-1 md-1 lg-1" class="media-list" statehandler="URL">' +
                '<wm-listtemplate layout="media">' +
                '<wm-container class="media-left">' +
                '<wm-picture data-is-target class="media-object picture" shape="circle" width="40pt" name="Picture" picturesource="{}" hint="{}"></wm-picture>' +
                '</wm-container>' +
                '<wm-container class="media-body">' +
                '<wm-label data-is-target caption="{}" name="Name" class="p media-heading" ></wm-label>' +
                '<wm-label data-is-target caption="{}" class="p text-muted" name="Title"></wm-label>' +
                '</wm-container>' +
                '<wm-container class="media-right media-top" width="20%" name="container9" horizontalalign="right">' +
                '<wm-buttongroup name="buttongroup1">' +
                '<wm-button type="button" class="btn-transparent edit-list-item" caption="" name="button1" iconclass="wi wi-pencil fa-2x" margin="unset 0.2em unset unset"></wm-button>' +
                '<wm-button type="button" class="btn-transparent delete-list-item" caption="" name="button2" iconclass="wi wi-trash fa-2x"></wm-button>' +
                '</wm-buttongroup>' +
                '</wm-container>' +
                '</wm-listtemplate>' +
                '</wm-list>' +
                '<wm-liveform  errormessage="" title="Details" formlayout="dialog" iconclass="wi wi-edit"><wm-layoutgrid></wm-layoutgrid></wm-liveform>'
            }
          ]
      }
    }

    //For template bundle project go with normal flow.
    if (widgetInfo.config && !this.projectService.isTemplateBundleType()) {
      set(config, 'configOptions', widgetInfo.config);
      set(config, 'template', widgetInfo.template);
      this.eventManager.emitOpenDialogWithID({dialogId: 'widgetConfigDialog', config: config});
      this._onCanvasMouseLeave();
    } else if (config.widgetType === 'wm-prefab' && config.prefabName) {
      this.prefabManager.registerPrefab(config.prefabName).then(this.cbRegisterPrefab.bind(this, config));
    } else {
      this.notifyAdd(config, browserEvent);
    }
  }

  swapWithPrev() {
    let $prev = $widget.prev();
    if ($prev.length) {
      this.swap($widget, $prev, 'prev');
    }
  }

  swapWithNext() {
    let $next = $widget.next();
    if ($next.is('.wm-focus-rect')) {
      $next = $next.next();
    }
    if ($next.length) {
      this.swap($widget, $next, 'next');
    }
  }

  swap($node1: JQuery<HTMLElement>, $node2: JQuery<HTMLElement>, _action: string, isTreeUpdated?: any) {

    let refPos, prevRefPos, config = {};

    set(config, 'widgetId', $node1.attr('widget-id'));
    set(config, 'parentId', $node1.parent().closest('[widget-id]').attr('widget-id'));

    if (_action === 'prev') {
      refPos = 'before';
      prevRefPos = 'after';
    }else if(_action === 'inside'){
      refPos = 'inside';
      prevRefPos = 'after';
    } else {
      refPos = 'after';
      prevRefPos = 'before';
    }

    set(config, 'referenceId', $node2);
    set(config, 'referencePos', refPos);
    set(config, 'prevParentId', $focusNode?.closest('[widgetid]').attr('widgetid'));
    set(config, 'prevReferenceId', $node2);
    set(config, 'prevReferencePos', prevRefPos);
     if (isTreeUpdated) {
        set(config, 'eventType', "TREE_NODE_MOVED");
    }

    this.notifyMovementForSort(config);
  }

  defineDnd() {

    this.$$canvas
      ?.off('dragstart dragend', '[widget-id]')
      .on('dragstart', '[widget-id]', (e: DragStartEvent) => {
        // @ts-ignore // TODO: check this setData type
        get(e, 'dataTransfer')?.setData('text', '_dummy_text_');
        $focusNode?.addClass('drag-in-action');
        $widget.addClass('drag-in-action');
        const nativeEv = e.originalEvent || e;

        const dt = this._getDataTransfer(nativeEv);

        if ($widget && $widget.length) {
          // $widget.addClass('moving-widget-overlay');
          this._ensureMovingOverlayNode($widget);
        }

        action = ACTIONS.MOVE;
        this.unObserveResizeObserver();
        this.pageStructureService.showTreeNode('canvasMove')

        // DISABLE HOVER EFFECTS DURING DRAG
        this.$$canvas?.find('.hover-highlight, .hover-sibling, .hover-sibling-allowed').removeClass('hover-highlight hover-sibling hover-sibling-allowed');
        this.$$canvas?.off('mousemove.selection mouseleave.selection');

        // create a drag preview (first selected widget used to compute icon/name)
        const primaryEl = ($widget && $widget.length) ? $widget.get(0) : (this.$selectedWidgets && this.$selectedWidgets.length ? this.$selectedWidgets.eq(0).get(0) : null);
        const $preview = this._createDragPreview(primaryEl as any);
        if ($preview && $preview.length && dt) {
          try {
            // ensure preview is in the DOM and visible for measurement
            $preview.css({ position: 'fixed', left: '-9999px', top: '-9999px', display: 'block' });
            // setDragImage expects a Node and offsets; DataTransfer comes from native event
            dt.setDragImage($preview[0], 12, 12);
          } catch (err) {
            // ignore errors (some browsers restrict setDragImage or throw)
          }
        }

        // RESET HIGHLIGHT
        this.clearDropHighlight();
        isHighlighted = false;
      })
      .on('dragend', '[widget-id]', (e: DragEndEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.unObserveResizeObserver();
        this._removeDragPreview();

        // if (!moveSuccess) {
        //   //revert to the original position
        //   $focusNode?.before($widget);
        // }
        this.cleanupMoveWidCancel();
        this.hideTreeNode();

        // RE-ENABLE HOVER EFFECTS AFTER DRAG END
        this.attachMouseEvents();

        // Update position from dragend event if valid (fallback to last known if 0,0)
        if (e.clientX !== 0 && e.clientY !== 0) {
          this._lastMouseClientX = e.clientX ?? (e.originalEvent && e.originalEvent.clientX) ?? null;
          this._lastMouseClientY = e.clientY ?? (e.originalEvent && e.originalEvent.clientY) ?? null;
        }

        // Trigger synthetic hover on the item under the last cursor position
        if (this._lastMouseClientX != null && this._lastMouseClientY != null) {
          this._triggerSyntheticHover(this._shiftPressed);
        }
      });

    this.$$canvas && this.$$canvas
      .off('dragover drop')
      .on('dragover', '[widget-id]', (e: DragOverEvent) => {
        e.preventDefault(); // allows us to drop
        e.stopPropagation();
        this.unObserveResizeObserver();

        const widgetsListEl = document.querySelector('.widget-list');
        const isInsideWidgetsList = widgetsListEl?.contains(e.target as Node);
        if (!isInsideWidgetsList) {
          if (!this.isPsTreeShown) {
            // dragged crossed the widget list
            this.pageStructureService.showTreeNode('addWidget');
            this.isPsTreeShown = true
          }
        }

        // Setting dropEffect to 'move' to remove the default green plus icon coming on drag
        const nativeEvt = (e as any).originalEvent ?? e;
        if (nativeEvt && nativeEvt.dataTransfer) {
          nativeEvt.dataTransfer.dropEffect = 'move';
        }

        this._pendingDragEvent = e;

        if (this._dragRafId) {
          return;
        }
        this._dragRafId = requestAnimationFrame(() => {
          this._dragRafId = null;
          const evt = this._pendingDragEvent;
          this._pendingDragEvent = null;

          $(evt.currentTarget).trigger('widgetdragover', [evt]);

          const currentWidgetId = $(evt.currentTarget).attr('widget-id');
          const moved = !(lastPos['pageX'] === evt.pageX && lastPos['pageY'] === evt.pageY);

          // allow processing when widget changed OR pointer actually moved since last processed event
          if (lastHoverWidId === currentWidgetId && !moved) {
            return;
          }
          lastHoverWidId = currentWidgetId;


          if (action === ACTIONS.MOVE) {
            this.handleMoveWidgetDrag(evt);
          } else {
            this.handleAddWidgetDrag(evt);
          }
        });
      })
      .on('drop', (e: DropEvent) => {
        e.stopPropagation();
        e.preventDefault();
        this.unObserveResizeObserver();
        this.hideTreeNode();

        if (action === ACTIONS.MOVE) {
          this.handleMoveWidgetDrop(e);
        } else {
          this.handleAddWidgetDrop(e);
        }
      });
  }

  hideTreeNode() {
    this.pageStructureService.hideTreeNode()
    this.isPsTreeShown = false;
  }

   // "wms:partial-container-params-modified"
  onPartialParamsModified(options: any) {
    /*get the markup object for the respective grid*/
    let _markup = this.getParamsMarkup(options.params),
      pageContainerNode: any = this.markupManager.getMarkup()?.find('[name="' + options.widgetName + '"]');
    const containerContent: string = pageContainerNode?.attr('content');
    if (containerContent && containerContent === options.content) {
      pageContainerNode?.empty();
      pageContainerNode?.append(_markup);
    }
  }

  getParamsMarkup(params: any) {
    let _markup = '',
      paramNode = 'wm-param';
    forEach(params, (param) => {
      if (isDefined(param.value) && param.value !== '') {
        _markup += '<' + paramNode + ' name="' + param.name + '" value="' + param.value + '" type="' + param.type + '"></' + paramNode + '>';
      }
    });

    return _markup;
  }

  cbRegisterPrefab(config: DroppedWidgetInfo, response: any) {
    if (response) {
      let errObj = response.error ? response.error : response;
      if (this.prefabManager.isPrefabVersionConflictError(errObj)) {
        this.dialogService.open('prefabConflictDialog', {
          'resolve': {
            'dialogParams': () => {
              return {
                'error': errObj,
                'prefabConfig': config,
                'prefabName': config.prefabName,
                'onOk': () => this.cleanupAddWidCancel.bind(this),
                'forceRegisterSuccess': (config: any) => {
                  this.notifyAdd(config);
                  this.wsManager.saveActiveWs.next(() => {
                    window.location.reload();
                  });
                }
              };
            }
          }
        });
      } else if (this.prefabManager.isCircularDependencyError(errObj)) {
        this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], get(errObj, 'errors.error[0].message'));
        this.cleanupAddWidCancel();
      } else {
        this.notificationService.show('error', this.locale['MESSAGE_ERROR_TITLE'], this.locale['MESSAGE_ERROR_PREFAB_REGISTER_FAILED_DESC']);
        this.cleanupAddWidCancel();
      }
    } else {
      this.notifyAdd(config);
    }
  }

  private applyResizeObserver(widget: JQuery<HTMLElement> | null) {
    this.activeWidgetResizeObserver?.disconnect();
    if (widget != null && widget.length) {
      this.activeWidgetResizeObserver = new ResizeObserver((entries) => {
        // We wrap it in requestAnimationFrame to avoid ResizeObserver loop limit exceeded error.
        window.requestAnimationFrame(() => {
          if (!Array.isArray(entries) || !entries.length) {
            return;
          }
          this.updateFocusNodePos();
        });
      });
      this.activeWidgetResizeObserver.observe(widget[0]);
    }
  }

  private unObserveResizeObserver() {
    if ($widget && $widget.length) {
      this.activeWidgetResizeObserver?.unobserve($widget[0]);
    }
  }

  private observeResizeObserver() {
    if ($widget && $widget.length) {
      this.activeWidgetResizeObserver?.observe($widget[0]);
    }
  }

  widgetRearrange(nodeData: any){
    const { dragData, targetNode, targetParent, position } = nodeData;
    let sourceNodeEle = this.getWidgetFromWidgetId(dragData.dataItem.props.widgetId)
    let targetNodeEle = this.getWidgetFromWidgetId(targetNode.props.widgetId)
    this.swap(sourceNodeEle,targetNodeEle, position, true)
  }

  treeNodeHighlight(container: any, type: any, side?: string, $refEl?: any){
     const draggingEl = ($widget && $widget.length) ? $widget.get(0) : (this.$selectedWidgets && this.$selectedWidgets.length ? this.$selectedWidgets.eq(0).get(0) : null);
     this.pageStructureService.treeNodeHighlight(container, type, draggingEl ,addWidgetInfo, side || '', $refEl || '', )
  }

  ngOnDestroy() {
    this.$$canvas?.off('.canvas-dom');
    this.$$canvas?.off('dragover drop');
    this.$$canvas?.off('dragstart dragend');

    this.$$canvas?.off('selection');
    if (this._hoverRafId) {
      cancelAnimationFrame(this._hoverRafId);
      this._hoverRafId = null;
    }
    this._hideHoverTooltip();

    this.destroy$.unsubscribe();
  }
}
